<template>
  <div style="height:100vh;width:100vw;">
    <OCBrowse v-if="enableOICBrowse" @close="enableOICBrowse=false" @traverToCatalog="setRouterUrl" :pIPList="parentIPList"></OCBrowse>
    <picture-in-picture ref="pic-pic" @hook:mounted="picPicZindex(9999999, 'pic-pic')" calss="hide-picture" v-cloak v-if="openPip" :selectedFile="selectedFileInfo"  @closeMiniPlayer="closeMinimisedPlayer"></picture-in-picture>
    <ImagePreviewDialog ref="fullscreen-pic" @hook:mounted="picPicZindex(9999999, 'fullscreen-pic')" class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="selectedFileInfo" @closeMiniPlayer="closeMinimisedPlayer"
    v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
    <div class="modal" tabindex="-1" role="dialog" style="z-index:9999">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="max-height: 64px; min-height: 64px;">
            <!-- <div v-if="workspaceList.length == 1" style="height:23px;width:20px;margin-inline-end: 6px;">
                  <img :src="logo" style="height:100%;width:100%">
            </div> -->
            <h6 class="modal-title ml-2">{{$t('Favourite Assets')}}</h6>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
              <span aria-hidden="true">
                <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;">
                </cancel-icon>
              </span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="h-100">
              <div class="favourites-browse-wrapper" style="display:flex;display: flex;padding: 6px 10px;">
                <div v-show="workspaceList.length > 1" style="height:38px;width:35px;">
                  <!-- <img :src="logo" style="height:100%;width:100%"> -->
                </div>
                <div class="navbar-header container-fluid" :class="[{overWriteContMargin:workspaceList.length > 1},{overWriteContainer: workspaceList.length == 1}]" style="display:flex;justify-content: space-between;">
                  <div class="search-bar-autocomplete-wrapper" style="position:relative;width:60%;display: flex;">
                    <div style="display:inline-block;width:94%">
                      <div style="width:100%;position:relative" @keyup.enter.stop.prevent="keywordSearchParameters()">
                        <Multiselect
                                    ref="globalSearch"
                                    id="gloabl_search_in_file_browse"
                                    v-model="keywordFilter"
                                    :options="searchKeywordListFromAutocomplete"
                                    :custom-label="selectionLabelCallback"
                                    :placeholder="$t('Search')"
                                    :preserveSearch="true"
                                    :show-no-results="false"
                                    :noOptions="true"
                                    :multiple="false"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    :allowEmpty="false"
                                    :clearOnSelect="false"
                                    :showNoOptions="false"
                                    @hook:mounted ="setAutocompleteOff()"
                                    @open="open"
                                    @keyup.enter.stop.prevent="keywordSearchParameters()"
                                    @search-change="getSearchKeywordsOnKeyup($event)"
                                    @select="keywordOptionsOnSelectCallback($event)"
                                    @remove="SearchKeywordOptionsOnRemoveCallback()"
                                    class="search-bar bg-transparent border-dark rounded"
                                    name="search"
                                    style="width:100% !important">
                        </Multiselect>
                        <svg v-if="keywordFilter != ''" v-on:click.prevent="clearSearchBarTextOnly()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg clear-icon" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
                          <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
                        </svg>
                        <svg @click="keywordSearchParameters()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search search-icon" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                        </svg>
                      </div>
                      
                    </div>
                    <div style="width:6%;display: flex;justify-content: center;position: relative;
                    top: 10px;align-items: flex-start;">
                      <svg v-if="!['tickets-display-component','tasks-display-component','issues-display-component'].includes(selectedComponent) && !showBins" @click="enableAdvancedSearchFunc()" :style='enableAdvancedSearch?"fill:#0779fb":""' xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        class="bi bi-sliders slider-icon" :class="{overWriteAdvIcon:workspaceList.length == 1}" style="margin-inline-start: 12px;" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"/>
                      </svg>
                    </div>
                  </div>
                  <div style="display:flex">
                    <div style="max-width: 400px;">
                      <users-multiselect
                        ref="favouritedByRef"
                        :showOptionLabel="true"
                        :enableAllOption="true"
                        :isSearchable="true"
                        :enableCheckbox="false"
                        :customizeLabel="$t('Favourites based on user')"
                        :customizePlaceholder="$t('Favourite done by')"
                        @updatedUsersList='handleFavouriteUserChange'
                        @removedUserCompleteData='handleFavouriteUserRemoved'
                        style="min-width: 220px !important;max-width: 227px !important;"
                        >
                    </users-multiselect>
                    </div>
                    <top-nav 
                    style="position: relative;bottom: 4px;"
                      @changeDirectoryFromUrl="changeDir" 
                      @changeComponent="changeComponent"
                      compoentType="FileBrowserWorkspace"
                      :dirs="dirs"
                      :usedBy="usedByCLabel"
                      :sortedOption="sortBy"
                      v-on:sort-by-filter-updated="sortBinsTable"
                      @fileStateFilterUpdated="updateFileStateFilter"
                      :folderBrowseEnabled="enableOnlyFolders"
                      >
                    </top-nav>
                    <div id="view_type" class="nav-item" style="position:relative;inset-inline-start:4px">
                      <a class="nav-item nav-link"  v-on:click="changeViewTypes()" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <svg xmlns="http://www.w3.org/2000/svg" v-if="gridView" width="2em" height="2em" fill="#C5c0c0" class="bi bi-grid-3x3-gap-fill" viewBox="0 0 16 16">
                        <title>{{$t('Grid view')}}</title>
                        <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"/>
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" v-if="!gridView" width="2em" height="2em" fill="#C5c0c0" class="bi bi-list-task" viewBox="0 0 16 16">
                        <title>{{$t('Table view')}}</title>
                        <path fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"/>
                        <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z"/>
                        <path fill-rule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"/>
                      </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-fluid sidenav">
                <div style="height:100%;display:inline-flex;width:100%;">
                  <div class="p-0 d-inline-flex h-100" :style="{'width':resizeAssetsWidth}">
                    <div class="h-100 p-0 w-100" :class="{unhideMetaDockComponent : 'col-md-8', getIsAssetsDetailsPanelVisible : 'col-md-12'}">
                      <advanced-search v-if="enableAdvancedSearch && !enableOnlyFolders"  :searchContext="browseContext" compType="subComp" @advancedSearchData="advancedSearchData" ref="advanceSearchRef"></advanced-search>
                        <div class="bins-browser" v-if='showBins && selectedComponent == "bins-display-component"'>
                            <bins-display ref="binsDisplay" @changeSelectedMainComponent="selectedMainComponent" @selectedRootBin="handleSelectedRootBin" :preSelectedBinIds="parentPreSelectedPathIds" :enabledFolderBrowse="enableOnlyFolders" :enableMultiSelect="enableAssetMultiSelect"></bins-display>
                        </div>
                        <div class="favourite-assets-wrapper" :style="resizedHeight">
                          <div
                            v-if="gridView == true"
                            class="assets-view-wrapper"
                            :ripple="false"
                            data-app
                            >
                            <div v-if="filesList.files.length == 0 && filesList.dirs.length == 0" style="text-align: center !important;">
                              <div style="font-size: 20px; margin-top: 8%; color: #686868;">
                                No Data Found
                              </div>
                            </div>
                            <div v-if="filesList.files.length !== 0" style="height: inherit;">
                              <div
                                class="text-left"
                                style="padding: 10px 0px 0px 20px; color: #777;display:none;"
                                >
                                <input v-if="enableAssetMultiSelect" v-on:change.stop="selectAllFiles" v-model='allFilesSelected' type="checkbox" class="text-light bigger-checkboxes" style="position: relative;top: 11px;inset-inline-end :5px;">
                                <svg  v-if="!showFiles" v-on:click="showFiles = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                    <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                </svg>
                                <svg v-if="showFiles" v-on:click="showFiles = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                    <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>{{$t('Files')}}
                              </div>
                              <ul v-if="showFiles" class="thumbnail-view-ul common-view-ul">
                                <!-- <drag-select-container attribute="attr" style="display:contents" @change="dragSelect($event)"> -->
                                  <li
                                    v-for="file in filesList.files"
                                    :key="file.file_uid"
                                    :attr="file.file_uid"
                                    @click.ctrl="multiSelectElemet(file)"
                                    @click.exact="selectElement($event, file)"
                                    @dblclick="showAssetDetails(file)"
                                    :class="{ activeAsset: fileUuids.includes(file.file_uid) }"
                                    :ripple="false"
                                    data-app
                                    style="position:relative"
                                    :title="getFileName(file)"
                                      >
                                    <div class="asset-thumbnail" onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue=false" >
                                      <div class="thumbnail-view" style="height: 93px;width: 160px;display: flex; align-items: center;" :class="file.state == 'MARK FOR DELETE'?'reduce-opacity':' '">
                                        <img :src="getThumbnailPath(file)" @error="replaceByDefaultImage" alt="image" draggable="false"/>
                                        <div v-if="'mime_type' in file && (file.mime_type.startsWith('video') || file.mime_type.startsWith('audio')) && 'duration' in file && file.duration"
                                              class="comm-thumbnail-view-duration-label">
                                              {{getHumanReadableDuration(file.duration)}}
                                        </div>
                                        <div v-if='checkIfDisabled(file)' :id="'assetResolution_'+file._id" class="thumbnail-view-resolution-label">
                                          {{ getReadableResolutionValue(file) }}
                                      </div>
                                      </div>
                                      <div class="storage-type-icons-wrapper" v-if="(file.storage_class != undefined && file.storage_class.length) || file.asset_type == 'subclip' || file.subclips_present == true">
                                        <svg v-if="file.subclips_present == true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                          <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                          <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                          <title>{{$t('Have subclips')}}</title>
                                        </svg>
                                        <template v-if="file.asset_type == 'subclip'">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                                            <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                            <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                            <title>{{$t('Subclip')}}</title>
                                          </svg>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;">
                                            <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                            <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                            <title>{{$t('Subclip')}}</title>
                                          </svg>
                                        </template>
                                        <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                          <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                          <title>{{$t('Amazon S3 Glacier')}}</title>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Deep Archive')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                          <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                          <title>{{$t('Amazon S3 Glacier Deep Archive')}}</title>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')" width="16" height="16" fill="currentColor" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                          <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                          <title>{{$t('Amazon S3 Glacier Instant Retrieval')}}</title>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Standard')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                          <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                          <title>{{$t('Amazon S3 Standard')}}</title>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" v-if="Object.keys(file).includes('archived') && file.archived" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16">
                                          <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                                          <title>{{$t('Archived')}}</title>
                                        </svg>
                                        <template v-if="'location_info' in file && 'gravity_deep' in file.location_info">
                                          <div v-for="cId of file.location_info.gravity_deep.container_ids" :key="cId">
                                            <svg v-if="cId == 'CACHE'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-c-square" viewBox="0 0 16 16">
                                              <title>{{ cId }}</title>
                                              <path d="M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"/>
                                              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"/>
                                            </svg>
                                            <svg v-else-if="cId.startsWith('Tape')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cassette-fill" viewBox="0 0 16 16">
                                              <title>{{ cId }}</title>
                                              <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"/>
                                              <path d="m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"/>
                                            </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                                              <title>{{ cId }}</title>
                                              <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                                            </svg>
                                          </div>
                                        </template>
                                      </div>
                                      <div v-if="!['GROWING'].includes(file.state) && file.asset_type != 'subclip'" class="shortcut-actions-type-icons-wrapper">
                                        <template v-if="!['MARK FOR DELETE'].includes(file.state)">
                                          <svg v-if="isPEnabled('Download')" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                            <title>{{$t('Download')}}</title>
                                            <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                            <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                          </svg>
                                        </template>
                                        <svg @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                          <path d="M0 0h24v24H0V0z" fill="none"/>
                                          <title>{{$t('Preview')}}</title>
                                          <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                        </svg>
                                        <div class="overflow-parent-div">
                                          <svg @click.stop.prevent="eOMenu=!eOMenu" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                            <title>{{$t('More actions')}}</title>
                                            <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                          </svg>
                                          <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                                <div class="copy-link-action" @click="setClipBoardText(file)" title="Copy link">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fdfff4" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                                      <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                                      <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                                  </svg>
                                                  {{$t('Copy link')}}</div>
                                                  <div class="copy-link-action" @click="openAssetInCatalog(file)" title="Open Parent Asset">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                                      <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                                    </svg>
                                                    {{$t('Open in Catalog')}}
                                                  </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="thumbnail-data d-inline-flex">
                                      <div v-html="getSvgIconsOfMediaTypes(file)" class="svg-icons-display"></div>
                                        <div class="file-name" :title="getFileName(file)" v-if="!getHighlightFilename(file,getFileName(file)).highlight">
                                          {{ getFileName(file) }}
                                        </div>
                                        <div class="file-name" :title="getFileName(file)" v-else v-html="getHighlightFilename(file,getFileName(file)).filename">
                                        </div>
                                    </div>
                                    <div v-if="(selectedComponent == 'catalogs-display-component' && file.asset_state != 'READY'
                                                && file.asset_state != 'MARK FOR DELETE') ||
                                                ('state' in file && file.state != 'READY' && file.state != 'MARK FOR DELETE')">
                                      <img
                                        :src="growingFileGif"
                                        alt="loading"
                                        style="height:50px;width:65px;position:absolute;bottom:40%;inset-inline-start:28%"
                                      />
                                    </div>
                                    <div v-else-if="(selectedComponent == 'catalogs-display-component' &&
                                                    file.asset_state == 'MARK FOR DELETE') ||
                                                    ('state' in file && file.state == 'MARK FOR DELETE')">
                                      <img
                                        :src="markForDeleteIcn"
                                        alt="markfordelete"
                                        style="height:20px;width:20px;position:absolute;bottom:55%;inset-inline-start:42%"
                                      />
                                    </div>
                                  </li>
                                <!-- </drag-select-container> -->
                              </ul>
                            </div>
                          </div>                            
                            <div v-else class="list-view-wrapper">
                              <div v-if="filesList.files.length == 0 && filesList.dirs.length == 0" style="text-align: center !important;">
                                <div style="font-size: 20px; margin-top: 8%; color: #686868;">
                                  No Data Found
                                </div>
                              </div>
                              <table v-else class="tabletable-with-border table-scroll small-first-col table-cell-styles" style="background: transparent;width:98%;margin:0px 10px !important;">
                                <thead>
                                  <tr style="height:40px">
                                    <!-- <th style="width:2%">
                                      <td>
                                        <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" v-model="allSelected"/>
                                      </td>
                                    </th> -->
                                    <th style="width:10%"></th>
                                    <th style="width:45%;text-align:start;position:sticky;inset-inline-start:7px;">{{$t('SlugName')}}</th>
                                    <th style="width:12%;text-align: center">{{$t('Date Created')}}</th>
                                    <th style="width:12%;text-align: center">{{$t('Date Added')}}</th>
                                    <th style="width:11%;text-align: center">{{$t('Size')}}</th>
                                    <th style="width:10%;text-align: center">{{$t('Created By')}}</th>
                                    <!-- <th style="width:10%;text-align:center" v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible">Type</th> -->
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="file in filesList.files">
                                    <tr :key="file._id" @click.exact="selectElement($event,file)"
                                        @dblclick="showAssetDetails(file,'list-view')"
                                        class="active-list-view"
                                        :class="{ activeAsset: fileUuids.includes(file.file_uid) }"
                                        @click.ctrl="multiSelectElemet(file)"
                                        > 
                                        <!-- <td>
                                          <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" v-model="selected" :value="file._id"/>
                                        </td> -->
                                      <td>
                          
                                        <div style="position:relative;margin-inline-start: 5px;">
                                          <div class="asset-thumbnail-hw-set" style="position:relative;">
                                            <div class="thumbnail-hw-set" :class="file.asset_state == 'MARK FOR DELETE' || file.state == 'ERROR'?'reduce-opacity':' '">
                                              <img :src="getThumbnailPath(file)"  @error="(e) => replaceByDefaultImage(e,file)" alt="image" draggable="false"/>
                                              <div v-if="'mime_type' in file && (file.mime_type.startsWith('video') || file.mime_type.startsWith('audio')) && 'duration' in file && file.duration"
                                                  class="comm-thumbnail-view-duration-label">
                                                  {{getHumanReadableDuration(file.duration)}}
                                                </div>
                                            </div>
                                            <div v-if='checkIfDisabled(file)' :id="'assetResolution_'+file._id" class="thumbnail-view-resolution-label">
                                                {{ getReadableResolutionValue(file) }}
                                            </div>
                                          <div v-if="eOMenu || !['GROWING'].includes(file.state)" class="shortcut-actions-type-icons-wrapper" :class="eOMenu?'overWriteShortcutIconWrapper':''" style="z-index:2;">
                                            <template v-if="!['MARK FOR DELETE'].includes(file.state)">
                                              <svg v-if="isPEnabled('Download')" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-download" viewBox="0 0 16 16">
                                                <title>Download</title>
                                                <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                              </svg>
                                            </template>
                                            <svg  @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#928f8f">
                                              <path d="M0 0h24v24H0V0z" fill="none"/>
                                              <title>{{$t('Preview')}}</title>
                                              <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                            </svg>
                                            <div class="overflow-parent-div">
                                              <svg @click.stop.prevent="eOMenu=true;selectElement($event,file,false);show($event, selectedFileInfo)" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                                <title>{{$t('More actions')}}</title>
                                                <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                              </svg>
                                              <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                                    <div class="copy-link-action" @click="setClipBoardText(file)" title="Copy link">
                                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fdfff4" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                                          <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                                          <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                                      </svg>
                                                      {{$t('Copy link')}}</div>
                                                  <div class="copy-link-action" @click="openAssetInCatalog(file)" title="Open Parent Asset">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                                      <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                                    </svg>
                                                    {{$t('Open in Catalog')}}
                                                  </div>
                                              </div>
                                            </div>
                                          </div>
                                            <div class="storage-type-icons-wrapper" v-if="(file.storage_class != undefined && file.storage_class.length) || file.asset_type == 'subclip' || file.subclips_present == true || (Object.keys(file).includes('asset_ttl') && file.asset_ttl) || (file.location_info && (Object.keys(file.location_info).includes('alto')|| Object.keys(file.location_info).includes('gravity_deep')))" style="bottom: -2px" :style="file.asset_type == 'subclip'?'min-width:40px;':''">
                                              <template v-if="file.asset_state != 'MARK FOR DELETE' && Object.keys(file).includes('asset_ttl') && file.asset_ttl">
                                                <div v-if="loadTTLIcons(file.asset_ttl)" v-html="loadTTLIcons(file.asset_ttl)" style="width: 22px;"></div>
                                              </template>
                                              <svg v-if="file.subclips_present == true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                                <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                                <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                                <title>{{$t('Have subclips')}}</title>
                                              </svg>
                                              <div v-if="file.asset_type == 'subclip'" style="position:relative;inset-inline-start:4px">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                                                  <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                                  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                                  <title>{{$t('Subclip')}}</title>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;top:1px">
                                                  <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                                  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                                  <title>{{$t('Subclip')}}</title>
                                                </svg>
                                              </div>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                <title>{{$t('Amazon S3 Glacier')}}</title>
                                              </svg>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Deep Archive')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                <title>{{$t('Amazon S3 Glacier Deep Archive')}}</title>
                                              </svg>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                <title>{{$t('Amazon S3 Glacier Instant Retrieval')}}</title>
                                              </svg>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Standard')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                <title>{{$t('Amazon S3 Standard')}}</title>
                                              </svg>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="Object.keys(file).includes('archived') && file.archived" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16">
                                                <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                                                <title>{{$t('Archived')}}</title>
                                              </svg>
                                              <template v-if="'location_info' in file && 'gravity_deep' in file.location_info">
                                                <div v-for="cId of file.location_info.gravity_deep.container_ids" :key="cId">
                                                  <svg v-if="cId == 'CACHE'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-c-square" viewBox="0 0 16 16">
                                                    <title>{{ cId }}</title>
                                                    <path d="M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"/>
                                                    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"/>
                                                  </svg>
                                                  <svg v-else-if="cId.startsWith('Tape')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cassette-fill" viewBox="0 0 16 16">
                                                    <title>{{ cId }}</title>
                                                    <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"/>
                                                    <path d="m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"/>
                                                  </svg>
                                                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                                                    <title>{{ cId }}</title>
                                                    <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                                                  </svg>
                                                </div>
                                              </template>
                                              <img v-if="file.location_info && Object.keys(file.location_info).includes('alto')" title="ALTO" :src="altoLogo" alt="alto"/>
                                            </div>
                                        </div>
                                        <img
                                          v-if="file.state == 'GROWING'  || file.asset_state == 'GROWING'"
                                          :src="growingFileGif"
                                          alt="loading"
                                          style="height:50px;width:65px;position:absolute;bottom:23%;inset-inline-start:19%;user-select: text !important;cursor:text;"
                                        />
                                        <svg v-else-if="file.state == 'ERROR'" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#af0000" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="position:absolute;bottom:35%;inset-inline-start:39%">
                                            <title>ERROR</title>
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                                        </svg>
                                        <img
                                          v-else-if="file.asset_state == 'MARK FOR DELETE'"
                                          :src="markForDeleteIcn"
                                          alt="markfordelete"
                                          style="height:20px;width:20px;position:absolute;bottom:26%;inset-inline-start:42%"
                                        />
                                        </div></td>
                                      <td style="text-align:start;position:relative;padding:15px;vertical-align: top;">
                                        <div>
                                          <div>
                                              <div v-html="getSvgIconsOfMediaTypes(file)" class="svg-icons-display" style="display:inline-table"></div>
                                              <span class="file-name-display-styles-in-list-view" :title="getFileName(file)" v-if="!getHighlightFilename(file,getFileName(file)).highlight">{{ getFileName(file) }}</span>  
                                              <span class="file-name-display-styles-in-list-view" :title="getFileName(file)" v-else v-html="getHighlightFilename(file,getFileName(file)).slugname"></span>
                                              <template v-if="file.highlight && file.highlight['metadata.description']">
                                                  <span v-for="desc in file.highlight['metadata.description']" :key="desc" v-html="desc"  class="secondary-dull-the-text description-alignment"></span>
                                              </template>
                                              <span v-else-if="!descriptionVisibilityArr.includes(file._id) && file.metadata && file.metadata.description && file.metadata.description.length > 200" class="secondary-dull-the-text description-alignment">&nbsp;-&nbsp;{{file.metadata.description.substring(0,200)}}...<span @click.stop.prevent="seeMoreDescription(file._id)"><b style="color:#bdbdbd">see more</b></span></span>
                                              <span v-else-if="!descriptionVisibilityArr.includes(file._id) && file.metadata && file.metadata.description" class="secondary-dull-the-text description-alignment">&nbsp;-&nbsp;{{file.metadata.description}}</span>
                                              <span v-else-if="descriptionVisibilityArr.includes(file._id) && file.metadata && file.metadata.description" class="secondary-dull-the-text description-alignment">&nbsp;-&nbsp;{{file.metadata.description}}</span>
                                              <div class="transcript-content-wrapper" style="display:flex;width: 100%; align-items: flex-start;margin-top: 11px;" v-if="file.highlight && file.highlight['files.ai_info.transcript.content']">
                                                <span style="flex-basis: 3%;display: flex;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-cc-square-fill" viewBox="0 0 16 16">
                                                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.408 5.89c-.83 0-1.318.64-1.318 1.753v.742c0 1.108.479 1.727 1.318 1.727.69 0 1.138-.435 1.187-1.05h1.147v.114c-.058 1.147-1.029 1.938-2.343 1.938-1.612 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.319 0 2.29.812 2.343 1.999v.11H6.595c-.049-.638-.506-1.108-1.187-1.108Zm5.404 0c-.831 0-1.319.64-1.319 1.753v.742c0 1.108.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05h1.147v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.318 0 2.29.812 2.342 1.999v.11h-1.147c-.048-.638-.505-1.108-1.186-1.108Z"></path>
                                                        <title>{{$t('Transcript')}}</title>
                                                    </svg>
                                                </span>
                                                  <div style="flex: 1;">
                                                    <span v-for="(transcriptContent,index) in file.highlight['files.ai_info.transcript.content']" :key="'files.ai_info.transcript.content'+index" v-html="getTranscriptHighlightContent(transcriptContent)"  class="secondary-dull-the-text transcript-content-highlight"></span>
                                                  </div>
                                              </div>
                                              <div  v-if="file.highlight && file.highlight['files.ai_info.ocr.script']" class="transcript-content-wrapper" style="display:flex;width: 100%; align-items: flex-start;margin-top: 11px;">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#eee">
                                                  <path d="M0 0h24v24H0z" fill="none"></path>
                                                  <path d="M17 4h3c1.1 0 2 .9 2 2v2h-2V6h-3V4zM4 8V6h3V4H4c-1.1 0-2 .9-2 2v2h2zm16 8v2h-3v2h3c1.1 0 2-.9 2-2v-2h-2zM7 18H4v-2H2v2c0 1.1.9 2 2 2h3v-2zM18 8H6v8h12V8z">
                                                  </path>
                                                  <title>{{$t('OCR')}}</title>
                                              </svg>
                                                  <div style="flex: 1;">
                                                    <span v-for="(ocrContent,index) in file.highlight['files.ai_info.ocr.script']" :key="'files.ai_info.ocr.script'+index" v-html="getTranscriptHighlightContent(ocrContent)"  class="secondary-dull-the-text transcript-content-highlight"></span>
                                                  </div>
                                              </div>
                                          </div>
                                          <div v-if="file.parent_path" class="d-flex" style="position: relative;inset-inline-start :0px;display:flex;font-size:12px;margin: 5px 0px;flex-wrap:wrap">
                                              <div v-for="(path,index) in file.parent_path" :key="path.id" class="dull-the-text comm-lengthy-value-styles">/{{modifyTextFormat(path.value)}}{{index == file.parent_path.length -1?'':','}}&nbsp;&nbsp;</div>
                                          </div>
                                          <div v-if="barcodeInfoFromStartup.enable_reference_id_workflow && file.reference_id" class="d-flex dull-the-text" style="position: relative;inset-inline-start :0px;display:flex;font-size:12px;flex-wrap:wrap;bottom: 4px;">
                                            {{barcodeInfoFromStartup.alias &&  barcodeInfoFromStartup.alias.alias_name?barcodeInfoFromStartup.alias.alias_name:"Reference ID"}}:
                                            <span style="color:#aaa"> &nbsp; {{file.reference_id}}</span></div>
                                          <div style="position: relative;inset-inline-start :-2px;display:flex;flex-wrap: wrap;">
                                          <span class="change-the-text-color mr-1 mb-1" v-if="Object.keys(file).includes('archived') && file.archived">Archived</span>
                                            <template v-if="file.location_info && Object.keys(file.location_info).includes('alto')">
                                              <span v-for="archivePath in file.location_info.alto.container_archive_path" class="change-the-text-color mr-1" :key="archivePath.container_id" style="white-space: pre-wrap;margin-bottom:2px;color: #46c5f5;border-color: #46b5f5;">{{archivePath.container_name}}</span>
                                            </template>
                                          <span class="change-the-text-color ml-1 mr-1 1 mb-1" v-if="file.storage_class != undefined && (file.storage_class.includes('Amazon S3 Glacier Instant Retrieval') || file.storage_class.includes('Amazon S3 Glacier') || file.storage_class.includes('Amazon S3 Standard') || file.storage_class.includes('Amazon S3 Glacier Deep Archive') )" style="color: #FFE15D;border: 1px solid #FFE15D;"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-fill" style="margin-bottom: 1px;" viewBox="0 0 16 16">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                              </svg> {{file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')?"Amazon S3 Glacier Instant Retrieval":file.storage_class.includes('Amazon S3 Glacier')?"Amazon S3 Glacier":file.storage_class.includes('Amazon S3 Glacier Deep Archive')?"Amazon S3 Glacier Deep Archive":"Amazon S3 Standard"}}</span>
                                            <div v-if="file.highlight && file.highlight['metadata.tag_values']" class="d-flex" style="flex-wrap:wrap">
                                              <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;" v-for="tag in file.highlight['metadata.tag_values']" :key="tag">
                                                <div style="display: flex;align-items: center;width: 12px;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-tag-fill" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                                                  </svg>
                                                </div>
                                                <div v-html="tag"></div>
                                              </div>
                                            </div>
                                            <div v-else-if="file.metadata && file.metadata.tag_values" class="d-flex" style="flex-wrap:wrap">
                                              <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;" v-for="tag in file.metadata.tag_values" :key="tag">
                                                <div style="display: flex;align-items: center;width: 12px;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-tag-fill" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                                                  </svg>
                                                </div>
                                                <div>{{tag}}</div>
                                              </div>
                                            </div>
                
                                            <div v-if="file.highlight && file.highlight['files.ai_info.face_values']" class="d-flex" style="flex-wrap:wrap;">
                                              <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.highlight['files.ai_info.face_values']" :key="detectedIndividual">
                                                <div style="display: flex;align-items: center;width: 12px;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                                                      <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"></path>
                                                      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path>
                                                      <title>{{$t('Profile')}}</title>
                                                  </svg>
                                                </div>
                                                <div v-html="detectedIndividual"></div>
                                              </div>
                                            </div>
                                            <div v-else-if="file.highlight && file.highlight['files.ai_info.face_detection.name']" class="d-flex" style="flex-wrap:wrap;">
                                              <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.highlight['files.ai_info.face_detection.name']" :key="detectedIndividual">
                                                <div style="display: flex;align-items: center;width: 12px;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                                                      <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"></path>
                                                      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path>
                                                      <title>{{$t('Profile')}}</title>
                                                  </svg>
                                                </div>
                                                <div v-html="detectedIndividual"></div>
                                              </div>
                                            </div>
                
                                            <div v-else-if="file && file.ai_info && file.ai_info.face_detection" class="d-flex" style="flex-wrap:wrap">
                                              <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.ai_info.face_detection" :key="detectedIndividual.uuid" v-show="detectedIndividual.name">
                                                <div style="display: flex;align-items: center;width: 12px;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                                                      <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"></path>
                                                      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path>
                                                      <title>{{$t('Profile')}}</title>
                                                  </svg>
                                                </div>
                                                <div >{{detectedIndividual.name}}</div>
                                              </div>
                                            </div>
                                            <div v-if="file.highlight && file.highlight['files.ai_info.obd_values']" class="d-flex" style="flex-wrap:wrap;">
                                              <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.highlight['files.ai_info.obd_values']" :key="detectedIndividual">
                                                <div style="display: flex;align-items: center;width: 12px;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-columns-gap" viewBox="0 0 16 16">
                                                      <path d="M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"></path>
                                                      <title>{{$t('Object')}}</title>
                                                  </svg>
                                                </div>
                                                <div v-html="detectedIndividual"></div>
                                              </div>
                                            </div>
                                            <div v-else-if="file.highlight && file.highlight['files.ai_info.obd.name']" class="d-flex" style="flex-wrap:wrap;">
                                              <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.highlight['files.ai_info.obd.name']" :key="detectedIndividual">
                                                <div style="display: flex;align-items: center;width: 12px;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-columns-gap" viewBox="0 0 16 16">
                                                      <path d="M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"></path>
                                                      <title>{{$t('Object')}}</title>
                                                  </svg>
                                                </div>
                                                <div v-html="detectedIndividual"></div>
                                              </div>
                                            </div>
                                            <div v-else-if="file && file.ai_info && file.ai_info.obd" class="d-flex" style="flex-wrap:wrap">
                                              <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.ai_info.obd" :key="detectedIndividual.uuid" v-show="detectedIndividual.name">
                                                <div style="display: flex;align-items: center;width: 12px;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-columns-gap" viewBox="0 0 16 16">
                                                      <path d="M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"></path>
                                                      <title>{{$t('Object')}}</title>
                                                  </svg>
                                                </div>
                                                <div >{{detectedIndividual.name}}</div>
                                              </div>
                                            </div>
                
                                          </div>
                                        </div>
                                          </td>
                                      <td :title="formatedDateandTime(file.asset_created_datetime)" style="vertical-align: top;padding-top: 15px;text-align: center">{{formatedDate(file.asset_created_datetime)}}</td>
                                      <td :title="formatedDateandTime(file.asset_added_datetime)" style="vertical-align: top;padding-top: 15px;text-align: center">{{formatedDate(file.asset_added_datetime)}}</td>
                                      <td style="text-align:center;vertical-align: top;padding-top: 15px;">{{humaniseSize(file)}}</td>
                                      <td class="text-left p-0 d-flex">
                                        <div v-for="user in file.favorite" :key="user._id" class='d-flex'>
                                          <div v-if="Object.keys(user).includes('profile_image') && !['undefined',null].includes(user.profile_image) && user.profile_image" class='user-name-or-image'>
                                              <img :src="getProxyConvertedURL(user.profile_image)" :title="user.username" @error="replaceWithUserIcon($event,user.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                          </div>
                                          <div v-else class="user-name-or-image" :title="user.username" :style="style(user.username)" >
                                            {{user.username.split("")[0]}}
                                          </div>
                                        </div>
                                      </td>
                                      <!-- <td style="text-align:center" v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible">{{file.asset_type}}</td> -->
                                    </tr>
                                  </template>  
                                </tbody>
                              </table>
                          </div>
                          <div>
                            <pagination
                              v-model="page"
                              :records="totalFiles"
                              :per-page="perPage"
                              @paginate="paginate"
                              :options="options"
                            />
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from "../../core/Topnavigation.vue";
import binsDisplay from "../../bins/BinsDisplay.vue";
import { mapMutations, mapActions, mapGetters } from "vuex";
import Utils from "../../../components.utils.js";
import {NotifierConstants} from "../../../components.constants.js";
import CancelIcon from "../../core/InlineCancelField.vue";
import Multiselect from 'vue-multiselect';
// import DragSelect from "drag-select-vue";
import Pagination from "vue-pagination-2";
import AdvancedSearch from "../../core/AdvancedSearch.vue";
import PictureInPicture from "../../files/MiniPlayer.vue";
import ImagePreviewDialog from '../../core/ImagePreviewDialog.vue';
import Constants from "../../../components.constants.js";
import highlightMixin from '../../../mixins/highlightMixin.js';
import userMultiSelect from "../../users/UserMultiselectField.vue";
import OpenCatalogBrowse from "../../categories/OpenInCatalogBrowse.vue";
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import "../../../../src/assets/common.scss"

Vue.use(VueCookies)

export default {
  mixins:[highlightMixin],
  components: {
    "users-multiselect":userMultiSelect,
    "picture-in-picture":PictureInPicture,
    ImagePreviewDialog,
    "advanced-search":AdvancedSearch,
    // 'drag-select-container': DragSelect,
    "Multiselect":Multiselect,
    "top-nav": TopNav,
    pagination: Pagination,
    "bins-display":binsDisplay,
    "cancel-icon": CancelIcon,
    "OCBrowse":OpenCatalogBrowse,
  },
  computed: {
    dirs() {
      let traversedFolders = this.getTraversedFolderList();
      return traversedFolders;
    },
    barcodeInfoFromStartup:{
        get(){
            return this.$store.state.startUpData.startUpDataDetails;
        }
    },
    ...mapGetters("users", [
      "getisMiniplayerVisible",
      "getLoggedInUserAccessControl",
      "getLoggedInUserPrivilege"
    ]),
  },
  methods: {
    openAssetInCatalog(file){
      this.parentIPList = [];
      if(file.asset_type == "subclip" &&  "master_asset_id" in file &&
        file.master_asset_id != undefined && file.master_asset_id.length > 0){
        this.selectedAssetId = file.master_asset_id;
      }else{
        this.selectedAssetId = file.asset_id
      }
      if(this.selectedAssetId){
        this.eOMenu = !this.eOMenu;
        let payload = {params:{assetId: this.selectedAssetId}}
        this.getAssetInfoFromServer(payload).then((data) => {
          if (data.statusCode==200){
            let selectedAssetDetails = data["asset"];
            if(selectedAssetDetails){
              if("parent_id_path" in selectedAssetDetails &&
                selectedAssetDetails.parent_id_path.length > 0){
                this.parentIPList = selectedAssetDetails.parent_path;
                if(selectedAssetDetails.parent_id_path.length == 1){
                  let pIPath = selectedAssetDetails.parent_id_path[0]
                  let cIdList = pIPath.split("/");
                  let catInfo = this.parentIPList[0];
                  this.setRouterUrl(cIdList[cIdList.length - 1],catInfo[catInfo.catalog_name], selectedAssetDetails.catalog_type)
                }else{
                  this.enableOICBrowse = true;
                }
              }
            }else{
              alert("Unable to open asset in Catalog. ")
              return
            }
          }else{
            this.$toast.error(data.message);
          }
        })
      }
    },

    setRouterUrl(catalogId, catalogName, catalogType){
      Utils.updateCookieByKeyName("context","catalogs-display");
      let query = {advanceFilter:JSON.stringify({fields:JSON.stringify({}), asset_id:this.selectedAssetId})}
      if(this.barcodeInfoFromStartup.enable_department){
        query = {advanceFilter:JSON.stringify({fields:{}, asset_id:this.selectedAssetId}), 'projects':'all', 'fromchild':true}
        Utils.setLocalStorageValue('selectedDepartmentsArr', JSON.stringify(['all']))
      }
      this.$router.push({
        name:"catalogs-display",
        params:{
                _id: catalogId, 
                catalog_name: catalogName,
                catalog_id: catalogId,
                catalog_type: catalogType
              },
        query: query
      })
      this.$emit("openAdvancedSearch")
      this.enableOICBrowse = false;
    },
    formatedDateandTime(date){
      return Utils.getDateAndTimeFormat(date)
    },
    modifyTextFormat(text){
      if(text){
          let temp = text.split("catalog://0/")[1];
          if(temp){
            temp = temp.replace("/","/")
            return temp;
          }
      }
    },
    getColorBasedOnExpiry(locationInfo){
      if(Object.keys(locationInfo).includes('aws') && Object.keys(locationInfo.aws).includes('restoration_expiry_datetime')){
        let currentDate = new Date();
        // Create the given date (replace with your desired date)
        let givenDate = new Date(locationInfo.aws.restoration_expiry_datetime);
        // Compare the dates
        if (currentDate > givenDate) {
          return 'currentColor'
        } else {
          return '#28a745'
        }
      }
      return 'currentColor'
    },
    getTraversedFolderList(){
      let traverPathList = []
      if(this.selectedComponent == "bins-display-component" && !this.showBins){
        if(this.rootPathPermission){
          let paths = this.rootPathPermission.name_path;
          paths = paths.replace("share://","");
          let pathList = paths.split("/");
          let pathIds = this.rootPathPermission.path;
          pathIds = pathIds.replace("share_id://","");
          let pathIdList = pathIds.split("/");
          for(let i = 0; i<pathList.length;i++){
            traverPathList.push({
              _id:pathIdList[i],
              file_name:pathList[i],
              permissions:this.rootPathPermission.permission
            })
          }
        }
      }else if(this.selectedComponent == 'catalogs-display-component'){
        if(this.rootPathPermission){
          let paths = this.rootPathPermission.name_path;
          paths = paths.replace("catalog://0/","");
          let pathList = paths.split("/");
          let pathIds = this.rootPathPermission.path;
          pathIds = pathIds.replace("catalog_id://0/","");
          let pathIdList = pathIds.split("/");
          for(let i = 0; i<pathList.length;i++){
            traverPathList.push({
              _id:pathIdList[i],
              file_name:pathList[i],
              permissions:this.rootPathPermission.permission
            })
          }
        }
      }
      this.folderStructure = traverPathList
      return this.folderStructure
    },
    selectAllFiles(event){
        if(event.target.checked){
          this.unselectElement();
          this.unselectAllFiles();
          for(let i = 0; i< this.filesList.files.length; i++){
            this.multiSelectElemet(this.filesList.files[i]);
            // this.isFileSelected(this.filesList.files[i])
          }
        }else{
            this.unselectElement();
            this.unselectAllFiles();
            this.deselectFileAndContextMenu();
        }
    },
    isFileSelected(fileInfo){
      if (fileInfo.file_uid && this.fileUuids.includes(fileInfo.file_uid)){
        return true
      }
    },
    replaceByDefaultImage(e){
      e.target.onerror = null
      e.target.src = Utils.getNoThumbnailImg();
    },
    //preview actions
    closeMinimisedPlayer(){
      this.openPip = false;
      this.showOtherFilesPreviewDialog = false;
    },
    picPicZindex(zvalue, ref){
      this.$refs[ref].$el.style.cssText += `z-index:${zvalue} !important`
    },
    showAssetDetailsDockCloseMiniplayer(){
      if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
        this.openPip = true;
    },
    showAssetDetailsDockCloseMaximisedplayer(){
      if(this.isFullscreenPreviewAllowed()){
        this.openPip = false;
        this.showOtherFilesPreviewDialog = true;
        return;
      }
    },
    isFullscreenPreviewAllowed(){
      let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
      return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.selectedFileInfo)) > -1
    },
    openPictureInPicture(){
      if(this.isFullscreenPreviewAllowed()){
        this.openPip = false;
        this.showOtherFilesPreviewDialog = true;
        return;
      }else{
        this.openPip = true;
        this.showOtherFilesPreviewDialog = false;
      }
    },
    //view styles
    changeViewTypes(){
      this.gridView = !this.gridView;
    },
    //Advance Search
    advancedSearchData(data){
      this.advanceSearchKeys = data;
      if(this.selectedComponent == "bins-display-component"){
        this.refreshFilesList(this.currentFolderInfo, false)
      }else{
        this.refreshCAssetsList(this.selectedCatalog, false);
      }
    },
    heightSet(){
      if(document.querySelector(".advanced-search-wrapper") != undefined){
        let height = document.querySelector(".advanced-search-wrapper").getBoundingClientRect().height;
        height = `calc(100% - ${height}px)`;
        this.resizedHeight  = `height:${height} !important;`;
      }else{
        this.resizedHeight  = "height:94%";
      }
    },
    deselectFileAndContextMenu(event=null,hardReload=false) {
      // if clicked on contextmenu item then don't proceed further to diselect element
      try{
         if(event && event.target.closest('.v-list-item').getAttribute('role') == 'menuitem') return true;
      }catch(e){console.log(e)}
      if (hardReload){
        event = {ctrlKey: false}
      }
      if (this.dragSelected){
        this.dragSelected = false
        return
      }
      if (event){
        try{
          event.stopImmediatePropagation()
        }catch(error){
          console.log("error",error)
        }
        if (!(event.ctrlKey)){
          this.unselectAllFiles();
        }
      }
      // this.closeContextMenu();
      this.unselectElement();
    },
    enableAdvancedSearchFunc(){
      this.enableAdvancedSearch = !this.enableAdvancedSearch;
      this.$nextTick(() => {
        this.resizeObservor = new ResizeObserver(() =>{
          // this.resizeObservor.disconnect();
          this.heightSet();
        });
          this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
      });
    },
    //catalogs display
    async setRootElement(){
      this.allFilesSelected = false
      let payload = {params:{catalog_id: Constants.rootCategory,asset_type:"catalog"}}
      let data = await this.getAllAssetsFromServer(payload);
      if (Constants.acceptedStatusCodes.includes(data.statusCode)){
        this.rootElement = data.assets[0]
        if("root_path_permissions" in data){
          this.rootPathPermission = data["root_path_permissions"];
        }
      }
    },
    initCBrowse() {
      this.folderStructure = []
      this.selectedCatalog = Object.assign({}, this.rootElement);
      let cInfo = {};
      if(Object.hasOwnProperty.call(this.selectedCatalog,'catalog_name') && this.selectedCatalog.catalog_name != 'undefined'){
          cInfo = { _id: this.selectedCatalog._id, file_name: this.selectedCatalog.catalog_name , pid: this.selectedCatalog.parent_id_path[0], catalog_name:this.selectedCatalog.catalog_name};
          this.folderStructure.push(cInfo);
      }
      this.refreshCAssetsList(cInfo, false);
    },
    switchCatalog(catalogInfo){
      this.keywordFilter = "";
      let parmsInfo={
          _id: catalogInfo._id,
          pid: catalogInfo.parent_id_path[0],
          file_name: catalogInfo.catalog_name,
          catalog_name: catalogInfo.catalog_name,
          catalog_id:catalogInfo._id,
      }
      this.refreshCAssetsList(parmsInfo, false);
    },
    deselectTraversedFolder(){
      this.fileUuids =[]
      this.unselectElement();
      this.unselectAllFiles();
      this.deselectFileAndContextMenu();
    },
    refreshCAssetsList(catalogInfo = {}, isPageClick) {
      console.log(`catalogInfo`,catalogInfo);
      this.allFilesSelected = false
      let payload = { params: {} };
      if(isPageClick){
        payload.params.page = this.page;
      }
      //payload.params.view_type = "list";
      payload.params.sort_by= this.sortBy.sortOn;
      payload.params.sort_order= this.sortBy.ascDesc;
     // payload.params.browse = true;
 /*      if(this.supportedBrowseMimeType && this.supportedBrowseMimeType.length > 0){
        payload.params.mime_type = JSON.stringify(this.supportedBrowseMimeType)
        payload.params.asset_type = 'catalog'
      } */
    
      //payload.params.catalog_id = this.selectedCatalog._id;
      if (this.keywordFilter && (this.keywordFilter != null && this.keywordFilter != undefined) && this.keywordFilter.length){
        payload.params.keyword = this.keywordFilter;
        delete payload.params.browse;
      }else{
        delete payload.params.keyword 
      }
      if(this.advanceSearchKeys != undefined && Object.keys(this.advanceSearchKeys).length){
          if('fields' in this.advanceSearchKeys && Object.keys(this.advanceSearchKeys.fields).length == 0){
              if(Object.keys(this.advanceSearchKeys).length > 1){
                payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
                delete payload.params.browse;
              }
          }else{
              payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
              delete payload.params.browse;
          }
        if(Object.keys(this.advanceSearchKeys).includes("fields") && Object.keys(this.advanceSearchKeys.fields).length == 0){
          delete payload.params.fields;
        }
      }
      
      let fileStateFromFilter = JSON.parse(localStorage.getItem('file-browse-file-status-filter-state'));
      if(this.assetsState && this.assetsState.state.length){
        payload.params.state = JSON.stringify(this.assetsState.state);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length){
        if(fileStateFromFilter.state && fileStateFromFilter.state.length){
          payload.params.state = JSON.stringify(fileStateFromFilter.state);
        }
      }else{
          delete payload.params.state;
      }

      if(this.assetsState && this.assetsState.filter.length > 0){
        payload.params.filter = JSON.stringify(this.assetsState.filter);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
        if(fileStateFromFilter.filter && fileStateFromFilter.filter.length > 0){
          payload.params.filter = JSON.stringify(fileStateFromFilter.filter);
        }
      }else{
        delete payload.params.filter;
      }

      if(this.favouriteUserId){
          payload.params.favorite_user_id = this.favouriteUserId;
      }else{
         payload.params.get_favorites = true;
      }
      this.getAllAssetsFromServer(payload).then((data) => {
        this.deselectTraversedFolder()
        this.totalPages = data["page_count"];
        this.page = data["page"];
        this.totalFiles = data["total_assets"];
        this.perPage = data["assets_per_page"]
        this.filesList = { dirs: [], files: [] }
        this.children = []
        for (const asset of data.assets) {
          if(asset.asset_type == 'catalog'){
              this.addFolder(asset,false)
            } else {
              if('asset_type' in asset && asset.asset_type == "subclip"){
                asset["file_uid"] = asset._id;
              }
              this.addFile(asset,false)
            }
          if(this.preSelectedPathIds.includes(asset._id)){
            if(this.preSelectedPathIds.length == 1){
              this.selectElement(null, asset)
            }else{
              this.multiSelectElemet(asset)
            }
          }
        }
        if("root_path_permissions" in data){
          this.rootPathPermission = data["root_path_permissions"];
        }
      });
    },
    //Component side menu
    switchWorkpace(panel){
      this.showFolders = true;
      this.showFiles = true;
      this.binSelected = null;

      this.currentFolderInfo = {};
      this.page = 1;
      this.folderStructure =[];
      this.unselectAllFiles();
      this.unselectElement();
      this.selectedComponent = panel;
      this.allFilesSelected = false;
      if(this.selectedComponent == 'catalogs-display-component'){
        this.gridView= true;
        this.browseContext = "catalogs-display";
        this.usedByCLabel = "Catalogs";
        this.showBins = false;
        this.folderStructure.push(this.rootCategory);
        this.initCBrowse();
      }else if(this.selectedComponent == 'bins-display-component'){
        this.gridView= true;
        this.browseContext = "bins";
        this.showBins = true;
        this.usedByCLabel = "Bins"
        this.rootPathPermission = null
      }else if(this.selectedComponent == 'tickets-display-component'){
        this.pamWorkspaceType = 'Ticket'
        this.gridView = false;
        if(this.enableAdvancedSearch){
          this.enableAdvancedSearch = false;
        }
        this.browseContext = "tickets";
        this.showBins = false;
        this.usedByCLabel = "Tickets";
        this.initPAMBrowse();
      }else if(this.selectedComponent == 'tasks-display-component'){
        this.pamWorkspaceType = "Task"
        this.gridView = false;
        if(this.enableAdvancedSearch){
          this.enableAdvancedSearch = false;
        }
        this.browseContext = "tasks";
        this.showBins = false;
        this.usedByCLabel = "Tasks";
        this.initPAMBrowse();
      }else if(this.selectedComponent == 'issues-display-component'){
        this.pamWorkspaceType = "Issue"
        this.gridView = false;
        if(this.enableAdvancedSearch){
          this.enableAdvancedSearch = false;
        }
        this.browseContext = "issues";
        this.showBins = false;
        this.usedByCLabel = "Issues";
        this.initPAMBrowse();
      }
    },
    //bins display
    selectedMainComponent(comp,binsData={}){
      if(binsData != undefined && Object.keys(binsData).length > 0){
        this.keywordFilter = "";
        this.showBins = false;
        this.selectedBinId = binsData.bin_id;
        let binInfo = {
          file_name:binsData.bin_name,
          _id:"0",
          path:"share://"+binsData.bin_id,
          permission:"full-control"
        }
        this.binSelected = binsData.bin_id
        this.folderStructure.push(binInfo)
        this.clearSearchBarTextOnly(true);
        this.refreshFilesList(binInfo, false)
      }
    },
    handleSelectedRootBin(binInfoList){
      if(binInfoList){
        if(binInfoList.length >1){
          for(let op of binInfoList){
            this.multiSelectElemet(op)
          }
          return
        }else{
          this.selectElement(null, binInfoList[0])
        }
      }else{
        this.deselectTraversedFolder()
      }
    },
    //////////////////////////
    // global search
    clearSearchBarTextOnly(forceClear = false){
      this.keywordFilter = "";
      this.searchKeywordListFromAutocomplete = [];
      this.searchedValue = [];
      this.lastSearch = [];
      this.$refs.globalSearch.search = "";
      if(!forceClear){
        this.keywordSearchParameters();
      }
      this.$nextTick(() => {
        this.resizeObservor = new ResizeObserver(() =>{
          // this.resizeObservor.disconnect();
          this.heightSet();
        });
          this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
      });
    },
    SearchKeywordOptionsOnRemoveCallback(){
      this.searchKeywordListFromAutocomplete = [];
    },
    keywordOptionsOnSelectCallback(option){
      this.keywordFilter = option;
      this.searchedValue = [];
      this.searchedValue.push(option);
      this.$refs.globalSearch.search = option;      
      this.keywordSearchParameters();
    },
    getSearchKeywordsOnKeyup(option){
      this.$nextTick(()=>{
        if(this.selectedMainComponent != 'review-display' && this.enabledComponent != 'projects-display'){
          let payload = {}
          this.searchKeywordListFromAutocomplete = [];
          if(typeof(option) != "undefined" && option.trim().length >= 2 && this.isAutoCompleteEnabled()){
            this.searchKeywordListFromAutocomplete.push(option);
            payload.params = {keyword:option};
            this.getSearchKeywordAutoComplitionFromServer(payload).then((data) => {
              let tempList = data["keywords"];
              this.searchKeywordListFromAutocomplete = this.searchKeywordListFromAutocomplete.concat(tempList.filter(ele => !this.searchKeywordListFromAutocomplete.includes(ele)));
            }); 
          }else{
            if(option == ""){
              this.searchKeywordListFromAutocomplete = [];  
            }else if(this.isAutoCompleteEnabled()){
              this.searchKeywordListFromAutocomplete = [];
              this.searchKeywordListFromAutocomplete.push(option);
            }else{
              this.keywordFilter = option
            }
          }
        }   
      });  
    },
    isAutoCompleteEnabled(){
      return JSON.parse(Utils.getLocalStorageValue('enable_auto_complete_for_assets_search'))
    },
    open() {
      this.searchedValue = this.lastSearch;
      this.$nextTick(() =>{
        this.$refs.globalSearch.$el
        .querySelector(".multiselect__input")
        .setSelectionRange(-1, -1);
      });
    },
    closed() {
      let search = this.$refs.globalSearch.search;
      if (!search) {
        this.searchedValue = [];
        return;
      }
      this.searchedValue = [];
      this.searchedValue.push(search);
      this.lastSearch = [];
      this.lastSearch.push(search);
      this.$emit("handleFilesBrowse",[], this.activeIndexInfo.apply_recursively);
    },
    postMessageToParentBlazeWindow(cmd,key,data){
        window.parent.postMessage({
            cmd: cmd,
            params: {
                [key]:data
            }
        },"*");
    },
    handleFileSelection(){
      let filesDetails = [];
      if(Object.keys(this.selectedFileInfo).length > 0){
        filesDetails = [this.selectedFileInfo]
      }else{
        for(let key of Object.keys(this.selectedFiles)){
        filesDetails.push(this.selectedFiles[key])
        }
      }
      if(this.$route.name == 'blaze_fusion_browse'){
        this.postMessageToParentBlazeWindow('attachMediaFiles','selected_file_info',filesDetails);
        return;
      }
      if(filesDetails && filesDetails.length > 0){
        this.$emit("handleFilesBrowse",filesDetails, this.activeIndexInfo.apply_recursively);
      }else if(this.enableOnlyFolders){
        alert("Please select path")
      }
    },
    setAutocompleteOff(){
       this.$refs.globalSearch.$el
        .querySelector(".multiselect__input").setAttribute("autocomplete", "off");
    },
    keywordSearchParameters(){
        if  (this.selectedComponent == "bins-display-component"){
          if([undefined, null].includes(this.binSelected) || this.binSelected.length <= 0){
            if(this.showBins && this.selectedComponent == "bins-display-component"){
              this.$refs.binsDisplay.filterBinsBy(this.keywordFilter)
              return
            }
            alert("Select any bin..!");
          }else{
            this.refreshFilesList(this.currentFolderInfo, false)
          }
          this.enableAdvancedSearch = true;
          this.$nextTick(() => {
            this.heightSet();
          });  
        }else if(["catalogs-display-component"].includes(this.selectedComponent)){
          this.enableAdvancedSearch = true;
          this.$nextTick(() => {
            this.heightSet();
          });
          if(this.selectedCatalog == undefined || !('_id' in this.selectedCatalog)){
            alert("Select any catalog. ");
          }else{
            this.refreshCAssetsList(this.selectedCatalog, false);
          }
        }else if(["tickets-display-component",'tasks-display-component','issues-display-component'].includes(this.selectedComponent)){
          this.initPAMBrowse(false);
        }
      },
      selectionLabelCallback(option){
        return `${option}`
      },
    //////////////////////////
    // assets display
    sortBinsTable(option){
      this.sortBy = option;
      if  (this.selectedComponent == "bins-display-component"){
        this.refreshFilesList(this.currentFolderInfo, false);
      }else{
        this.refreshCAssetsList(this.selectedCatalog, false);
      }
    },
    changeDir(fileInfo){
      if  (this.selectedComponent == "bins-display-component"){
        this.currentFolderInfo = fileInfo;
        this.refreshFilesList(fileInfo, false);
      }
      else{
        if(fileInfo._id == this.rootElement._id){
          this.initCBrowse();
        }else{
          this.selectedCatalog = fileInfo;
          this.refreshCAssetsList(this.selectedCatalog, false);
        }
      }
    },
    isPEnabled(priv) {
      // console.log("%%%%%%%%%%%%%%%%%%%%%%%%", this.getLoggedInUserPrivilege)
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
    },
    format(date) {
      date = new Date(date);
      const day = `${date.getUTCDate()}`.padStart(2, "0");
      const month = `${date.getUTCMonth() + 1}`.padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    },
    changeComponent() {
      this.binSelected = "";
      this.showBins = true;
      this.folderStructure = []
    },
    paginate(page) {
      this.allFilesSelected = false
      this.page = page;
      if(['tickets-display-component','tasks-display-component',"issues-display-component"].includes(this.selectedComponent)){
        this.initPAMBrowse(true);
      }else if(this.selectedComponent == "catalogs-display-component"){
        this.refreshCAssetsList(this.selectedCatalog, true);
      }else if(!this.showBins && this.binSelected){
        this.refreshFilesList(
          this.folderStructure[this.folderStructure.length - 1], true
        );
      }
    },
    formatedDate(date){
      return Utils.getDateFormat(date);
    },
    closeModal() {
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
    },
    close(){
      //this.$emit('close')
      this.closeModalCompoent();
    },
    getMimeType(type) {
      if(type == null){
        return "-"
      }
      let givenType = type.split("/")[0];
      if (givenType == "application") {
        givenType = "app";
      }
      return givenType;
    },
    humaniseSize(file) {
      if(file.size){
        let data = Utils.humanizeSize(file.size);
        return `${data["value"]} ${data["unit"]}`;
      }else{
        return '-'
      }
    },
    getFileName(file) {
      if(this.selectedComponent == "catalogs-display-component"){
        return file.slug_name;
      }
      if (file.file_name) {
        return file.file_name;
      } else {
        return Utils.getBaseName(file.path);
      }
    },
    selectElement(event, fileInfo) {
      // if (event != null) {
      //   event.stopImmediatePropagation();
      // }
      this.unselectAllFiles()
      this.selectedFileInfo = fileInfo;
      if (this.enableOnlyFolders || (!["folder", "catalog"].includes(fileInfo.asset_type))) {
        let sFUid = fileInfo._id
        if('file_uid' in fileInfo){
          sFUid = fileInfo.file_uid
        }
        this.fileUuids.push(sFUid)
      }
    },
    multiSelectElemet(fileInfo){
      let temp = this.selectedFiles;
      if(!this.enableAssetMultiSelect || (["folder", "catalog"].includes(fileInfo.asset_type) && !this.enableOnlyFolders)){
        return true;
      }
      let sFUid = fileInfo._id
      if('file_uid' in fileInfo){
        sFUid = fileInfo.file_uid
      }
      if(this.fileUuids.includes(sFUid)){
        this.fileUuids = this.fileUuids.filter(op=> op != sFUid);
      }else{
        this.fileUuids.push(sFUid)
      }
      if (temp[sFUid]){
          delete temp[sFUid]
          return true;
      }
      if (Object.keys(this.selectedFileInfo).length != 0){
        temp[sFUid] = fileInfo;
        if('file_uid' in this.selectedFileInfo){
          temp[this.selectedFileInfo.file_uid] = this.selectedFileInfo;
        }else{
          temp[this.selectedFileInfo._id] = this.selectedFileInfo;
        }
      }
      // else{
        temp[sFUid] = fileInfo;
        this.selectedFiles = temp
        if(this.enableAssetMultiSelect){
          this.selectedFileInfo = {}
        }
      if((Object.keys(this.selectedFiles) <= 1|| Object.keys(this.selectedFileInfo).length ) && this.eOMenu){
        this.eOMenu = false;
      }
      // }
    },
    dragSelect(event){
      if (event.length<=1 || !this.enableAssetMultiSelect){
        return
      }
      if(event && event.length>= 1)
      this.unselectElement();
      let assetIdlist = [].concat(event)
      this.unselectAllFiles()
      for (const assetId of assetIdlist) {
        let fileInfo = this.getFileInfoByAssetIdFromInMem(assetId)
        if (Object.keys(fileInfo).length !=0){
          if('file_uid' in fileInfo){
            this.fileUuids.push(fileInfo.file_uid);
          }else{
            this.fileUuids.push(fileInfo._id);
          }
          this.selectedFiles[fileInfo._id] = fileInfo
          this.dragSelected = true
        }
      }
    },
    getFileInfoByAssetIdFromInMem(asset_id){
      if(this.filesList.files.length <= 0){
        return {}
      }
      let fileinfo = this.filesList.files.filter((file_)=>file_._id==asset_id);
      if(fileinfo.length != 0){
          return fileinfo[0]
      }
    
      return {}
    },
    unselectElement() {
      this.selectedFileInfo = {};
    },
    setClipBoardText(file){
      let copiedLink = ""
      if(Object.keys(file).length && "access_url" in file){
        copiedLink = file.access_url;
      }
      if(copiedLink.trim().length <= 0){
        alert("Link is not avaialble.");
      }else{
        navigator.clipboard.writeText(copiedLink);
      }
      this.eOMenu = !this.eOMenu;
    },
    showAssetDetails(file) {
      this.clearSearchBarTextOnly(true)
      this.selectElement(null, file);
      if (file.asset_type === "file") {
        this.openPictureInPicture();
      } else {
        if(this.selectedComponent == "catalogs-display-component"){
          this.selectedCatalog = file;
          this.refreshCAssetsList(this.selectedCatalog, false);
          return;
        }
        if(!this.currentFolderInfo) this.currentFolderInfo = {};
          Object.assign(this.currentFolderInfo, file);
        this.refreshFilesList(file, false)
      }
    },
    multiPAMEntrySelection(fileInfo){
      let temp = this.selectedFiles;
      if(!this.enableAssetMultiSelect){
        return true;
      }
      if(this.fileUuids.includes(fileInfo._id)){
        this.fileUuids = this.fileUuids.filter(op=> op != fileInfo._id);
      }else{
        this.fileUuids.push(fileInfo._id)
      }
      if (temp[fileInfo._id]){
          delete temp[fileInfo._id]
          return true;
      }
      if (Object.keys(this.selectedFileInfo).length != 0){
        temp[fileInfo._id] = fileInfo;
        temp[this.selectedFileInfo._id] = this.selectedFileInfo;
      }
      // else{
        temp[fileInfo._id] = fileInfo;
        this.selectedFiles = temp
        if(this.enableAssetMultiSelect){
          this.selectedFileInfo = {}
        }
      // }
    },
    selectPAMElement(event, fileInfo) {
      this.unselectAllFiles()
      this.selectedFileInfo = fileInfo;
      this.fileUuids.push(fileInfo._id)
    },
    showPAMDetails(file){
      this.selectPAMElement(null,file);
      this.viewPamEntryDetails = true;
    },
    getThumbnailPath(file) {
      return Utils.getThumbnailPathfromFileInfo(file);
    },
    getHumanReadableDuration(duration){
      return Utils.getDurationInSeconds(duration)
    },
    is4K(fileWidth, fileHeight) {
      return fileWidth >= 3840 || fileHeight >= 3840
    },
    isFHD(fileWidth, fileHeight) {
      return fileWidth >= 1920 || fileHeight >= 1920
    },
    isHD(fileWidth, fileHeight) {
      return fileWidth >= 1280 || fileHeight >= 1280
    },
    isSD(fileWidth, fileHeight) {
      return fileWidth >= 720 || fileHeight >= 720
    },
    getReadableResolutionValue(file){
      let resKey = null
      let newClassName = null
      if('width' in file && 'height' in file){
        if(this.is4K(file.width, file.height)){
          newClassName = "res-fourK"
          resKey = "4K"
        }else if (this.isFHD(file.width, file.height)) {
          newClassName = "res-FHD"
          resKey = "FHD"
        }else if(this.isHD(file.width, file.height)){
          newClassName = "res-HD"
          resKey = "HD"
        }else if(this.isSD(file.width, file.height)){
          newClassName = "res-SD"
          resKey = "SD"
        }
        if(newClassName){
          this.$nextTick(()=>{
            let divId = "assetResolution_"+file["_id"];
            if(document.querySelector("#"+divId))document.querySelector("#"+divId).classList.add(newClassName)
          });
        }
      }
      if(!resKey && document.getElementById("assetResolution")){
        document.getElementById("assetResolution").remove()
      }
      return resKey
    },
    checkIfDisabled(file){
      if(file.mime_type && file.mime_type.startsWith('image')){
        if(this.barcodeInfoFromStartup && this.barcodeInfoFromStartup.disable_resolution_display_for_image){
          return false;
        }
      }
      if(file.mime_type && file.mime_type.startsWith('video')){
        if(this.barcodeInfoFromStartup && this.barcodeInfoFromStartup.disable_resolution_display_for_video){
          return false;
        }
      }
      return true;
    },
    fileExistsinMem(file_uid, file_info_list){
      let file_info = file_info_list.filter((file_)=>file_.file_uid==file_uid)
      if (file_info.length!=0){
        return true
      }
      return false
    },
    sortFoldersByDate(){
      this.filesList.dirs.sort((first, second)=>{
              let d1 = new Date(first.modified_datetime)
              let d2 = new Date(second.modified_datetime)
              return d2-d1;
            })
    },
    sortfilesByDate(){
      this.filesList.files.sort((first, second)=>{
              let d1 = new Date(first.modified_datetime)
              let d2 = new Date(second.modified_datetime)
              return d2 - d1;
            })
    },
    addFolder(folder_info, sort_by_date=false){
      if(!this.defaultPermissions.includes(folder_info.permissions)){
        return
      }
      if (!(this.fileExistsinMem(folder_info, this.filesList.dirs))){
        this.filesList.dirs.push(folder_info);
        if (sort_by_date){
          this.sortFoldersByDate()
        }
        
      }
    },
    addFile(file_info,sort_by_date=false){
      if (!(this.fileExistsinMem(file_info, this.filesList.files))){
        this.filesList.files.push(file_info);
        if (sort_by_date){
          this.sortfilesByDate()
        }
      }
    },
    updateFolder(file, sort_by_date=false){
      let file_info = this.filesList.dirs.filter((file_)=>file_.file_uid==file.file_uid)
      if (file_info.length !=0){
        Object.assign(file_info[0], file)
        if (sort_by_date){
          this.sortFoldersByDate()
        }
      }
    },
    updateFile(file, sort_by_date=false){
      let file_info = this.filesList.files.filter((file_)=>file_.file_uid==file.file_uid)
      if (file_info.length !=0){
        if(!Object.hasOwnProperty.call(file,'permissions')) Object.assign(file,{permissions:this.currentFolderInfo.permissions});
        Object.assign(file_info[0], file);
        if (sort_by_date){
          this.sortfilesByDate()
        }
      }
    },
    removeFolder(file, sort_by_date=false){
      this.filesList.dirs = this.filesList.dirs.filter((file_)=>file_.file_uid!=file.file_uid)
      if (sort_by_date){
          this.sortFoldersByDate()
      }
    },
    removeFile(file, sort_by_date=false){
      this.filesList.files = this.filesList.files.filter((file_)=>file_.file_uid!=file.file_uid)
      if (sort_by_date){
          this.sortfilesByDate()
      }
    },
    addToFileList(file,sort_by_date=false){
      if ("file_type" in file && file.file_type === "folder") {
        let assetEntry = file;
        assetEntry["asset_type"] = "folder"
        this.addFolder(assetEntry,sort_by_date)
      } else {
        this.addFile(file,sort_by_date)
      }
    },
    updateFileList(file, sort_by_date=false){
      if (file.asset_type === "folder") {
        this.updateFolder(file,sort_by_date)
      } else {
        this.updateFile(file,sort_by_date)
      }
    },
    removeFromFileList(file, sort_by_date=false){
      if (file.asset_type === "folder") {
        this.removeFolder(file,sort_by_date)
      } else {
        this.removeFile(file,sort_by_date)
      }
    },
    updateFileStateFilter(statesArr){
      if(statesArr && Object.keys(statesArr).length){
        this.assetsState = statesArr;
      }else{
        this.assetsState = null;
      }
      if(this.selectedComponent == "bins-display-component"){
        this.refreshFilesList(this.currentFolderInfo, false)
      }else{
        this.refreshCAssetsList(this.selectedCatalog, false);
      }
    },
    refreshFilesList(fileInfo = {}, isPageClick) { 
      this.allFilesSelected = false
      this.showBins = false;
      let payload = { params: {} };
      if(isPageClick){
        payload.params.page = this.page;
      }
      payload.params.bin_id = `${this.binSelected}`;
      payload.params.browse = true;
      payload.params.sort_by= this.sortBy.sortOn;
      payload.params.sort_order= this.sortBy.ascDesc;
      payload.params.view_type = "list";
      if ((fileInfo != undefined || fileInfo != null) && Object.keys(fileInfo).length != 0) {
        if (!["0", this.binSelected].includes(fileInfo._id)) {
          payload.params._id = fileInfo._id;
          delete payload.params.bin_id
        }
        let alreadyInBin = false;
        for (let dir of this.folderStructure) {
          if (dir._id === fileInfo._id) {
            alreadyInBin = true;
          }
        }
        if (!alreadyInBin) {
          this.addFileinfoToFolderStructure({
            _id: fileInfo._id,
            file_name: this.getFileName(fileInfo),
            permissions: fileInfo.permissions,
          });
        }
      }
      if (this.keywordFilter && this.keywordFilter != undefined && this.keywordFilter.length){
        payload.params.keyword = this.keywordFilter;
        delete payload.params.browse;
      }else{
        delete payload.params.keyword;
      }
      if(this.advanceSearchKeys != undefined && Object.keys(this.advanceSearchKeys).length){
          if('fields' in this.advanceSearchKeys && Object.keys(this.advanceSearchKeys.fields).length == 0){
              if(Object.keys(this.advanceSearchKeys).length > 1){
                payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
                delete payload.params.browse;
              }
          }else{
              payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
              delete payload.params.browse;
          }
        if(Object.keys(this.advanceSearchKeys).includes("fields") && Object.keys(this.advanceSearchKeys.fields).length == 0){
          delete payload.params.fields;
        }
      }

      let fileStateFromFilter = JSON.parse(localStorage.getItem('file-browse-file-status-filter-state'));
      if(this.assetsState && this.assetsState.state.length){
        payload.params.state = JSON.stringify(this.assetsState.state);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length){
        if(fileStateFromFilter.state && fileStateFromFilter.state.length){
          payload.params.state = JSON.stringify(fileStateFromFilter.state);
        }
      }else{
          delete payload.params.state;
      }

      if(this.assetsState && this.assetsState.storage_class.length){
        payload.params.storage_class = JSON.stringify(this.assetsState.storage_class);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
        if(fileStateFromFilter.storage_class && fileStateFromFilter.storage_class.length){
          payload.params.storage_class = JSON.stringify(fileStateFromFilter.storage_class);
        }
      }else{
        delete payload.params.storage_class;
      }

      if(this.assetsState && this.assetsState.filter.length > 0){
        payload.params.filter = JSON.stringify(this.assetsState.filter);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
        if(fileStateFromFilter.filter && fileStateFromFilter.filter.length > 0){
          payload.params.filter = JSON.stringify(fileStateFromFilter.filter);
        }
      }else{
        delete payload.params.filter;
      }

      if(this.enableOnlyFolders){
        payload.params["file_type"] = "folder"
      }
      payload.params.get_favorites = true;
      if(this.favouriteUserId){
          payload.params.favorite_user_id = this.favouriteUserId;
      }
      this.getAllFilesFromServer(payload).then((data) => {
        this.deselectTraversedFolder()
        if (!Utils.isAcceptedStatusCode(data.statusCode)) {
          this.filesList = { dirs: [], files: [] };
          return;
        }
        this.totalPages = data["page_count"];
        this.page = data["page"];
        this.totalFiles = data["total_assets"];
        this.perPage = data["assets_per_page"];
        this.filesList = { dirs: [], files: [] };
        this.unselectElement();
        this.unselectAllFiles()
        for (let file of data["files"]) {
          this.addToFileList(file)
          if(this.preSelectedPathIds.includes(file._id) || this.preSelectedPathIds.includes(file.path)){
            if(this.preSelectedPathIds.length == 1){
              this.selectElement(null, file)
            }else{
              this.multiSelectElemet(file)
            }
          }
        }
        this.showBins = false;
        if(this.filesList.dirs.length > 0){
          this.showFolders = true;
        }else{
          this.showFolders = false;
        }
        if("root_path_permissions" in data){
          this.rootPathPermission = data["root_path_permissions"];
        }
      });
    },
    initBrowse() {
      let fileInfo = {
        _id: "0",
        file_name: this.binSelected,
        permissions: "full-control",
      };
      this.addFileinfoToFolderStructure(fileInfo);
    },
    addFileinfoToFolderStructure(fileInfo){
      let file_found = this.folderStructure.filter((info)=>info._id==fileInfo._id)
      if (file_found.length ==0){
        this.folderStructure.push(fileInfo)
      }
    },
    unselectAllFiles(){
      this.selectedFiles = {}
      this.fileUuids = []
      this.dragSelected = false
    },
    getMediaTypeIcons(item) {
      if (item.startsWith("audio")) return Utils.getAudioPlayIcon();
      if (item.startsWith("video")) return Utils.getVideoPlayIcon();
    },
    getSvgIconsOfMediaTypes(path, type) {
      return Utils.determineSvgIconForType(path, type);
    },
    getBinAccessRight() {
      return this.getLoggedInUserAccessControl.bins.filter(
        (binAccessRight) =>
          binAccessRight.bin_id == this.binSelected &&
          binAccessRight.path == `share://${this.binSelected}`
      );
    },
    updateProxyForPath(notification){
      if(notification.message){
        let path = notification.message.path
        let fileinfo = this.filesList.files.filter((file_)=>file_.path==path);
        if(fileinfo.length != 0){
          this.refreshFilesList(this.currentFolderInfo, false)
        }
      }
    },
    isFolderExists(folderPath){
      let folderinfo = this.filesList.dirs.filter((file_)=>file_.path==folderPath);
      if(folderinfo.length != 0){
        return true
      }
      return false
    },
    async handleDownloadAction(file){
        let payload = {};
        let fileName = file.slug_name;
        payload.bin_id = file.bin_id;
        payload.path = file.path;
        payload.file_name = file.file_name;
        payload.element_type = "file";
        payload.job_name = "Download";
        this.initiateDownloadJob(payload).then((data) => {
          let jobIdFromResponse = data.job_id;
          let payload = {};
          payload = { job_id: "job_id=" + jobIdFromResponse };
          let downnloadUrl = `${Constants.downloadUrl}?${payload.job_id}`;
          const link = document.createElement("a");
          link.href = downnloadUrl;
          link.download = fileName;
          link.click(); 
            
          if (Utils.isAcceptedStatusCode(data.statusCode) == 200) {
            console.log("Download initiated");
          } else {
            this.$toast.error(data.message);
          }
        });
    },
    handleAssetCreatedNotificaton(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        let file_info = notification.message;
        if("master_asset_id" in file_info && file_info.master_asset_id != null){
          let file_exists = this.filesList.files.filter((file_)=>file_.asset_id==file_info.master_asset_id)
          if(file_exists.length > 0){
              file_exists[0].subclips_present = true;
          }
        }
    },
    handleBinRemovedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let bin_info = notification.message
        if (notification.message_type == NotifierConstants.binRemovedNotification){
          if(bin_info.bin_id == this.selectedBinId){
            this.$toast.info("Selected bin is deleted by other user")
          }
        }
      }
    },
    handleFileCreateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let parent_path = notification.message.parent_path
        let add_to_list = false
        if (this.currentFolderInfo.path == undefined){
          if (parent_path == `share://${this.binSelected}`){
            add_to_list = true
          }
        }else if(this.currentFolderInfo.path == parent_path){
          add_to_list = true
        }
        if (add_to_list){
          this.addToFileList(notification.message, true)
        }
      }
    },
    handleFileUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let parent_path = notification.message.parent_path
        let update_to_list = false 
        if (this.currentFolderInfo.path == undefined){
          if (parent_path == `share://${this.binSelected}`){
            update_to_list = true
          }
        }else if(this.currentFolderInfo.path == parent_path){
          update_to_list = true
        }
        if (update_to_list){
          this.updateFileList(notification.message, true)
        }
      }
    },
    handleAssetRemovedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if("master_asset_have_subclips" in notification.message && "master_asset_id" in notification.message){
        let asset_id_check = this.filesList.files.filter((asset)=>asset.asset_id==notification.message.master_asset_id)
        if(asset_id_check.length > 0){
              if(notification.message.master_asset_have_subclips == false)
                asset_id_check[0].subclips_present = false;
          }
        }
    },
    handleFileRemovedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let parent_path = notification.message.parent_path
        let remove_from_list = false
        if (this.currentFolderInfo.path == undefined){
          if (parent_path == `share://${this.binSelected}`){
            remove_from_list = true
          }
        }else if(this.currentFolderInfo.path == parent_path){
          remove_from_list = true
        }
        if (remove_from_list){
          this.removeFromFileList(notification.message, true)
        }
      }
    },
    handleFileArchivedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let job_info = notification.message
      let job = this.filesList.files.filter((job_)=>job_.path == job_info.path);
      if (job.length != 0){
        job = job[0];
        job.storage_class = job_info.storage_class;
      }
    },
    //PAM algorithm
    getProfileImageOfUser(image){
      let defaultImage = Utils.getNoThumbnailImg()
        let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
      return profileImageTag;
    },
    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },
    style(name){
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
      }
      return style
    },
    formatedDateField(date){
      return Utils.getOnlyDateFormat(date);
    },
    formatDateAndTime(date){
      return Utils.getDateAndTimeFormat(date);
    },
    initPAMBrowse(isPageClick = false){
      let payload = {params:{task_type:this.pamWorkspaceType}}
      if(isPageClick){
        payload.params.page = this.page
      }if(![undefined, null].includes(this.selectedProject) && this.selectedProject._id != "All"){
        payload.params.project_id = this.selectedProject._id;
      }
      if(![undefined,null].includes(this.createdByUserId) && this.createdByUserId.length>0){
        payload.params.created_by_id = this.createdByUserId
      }
      if(![undefined,null].includes(this.assigneeUserId) && this.assigneeUserId.length>0){
        payload.params.users = JSON.stringify(this.assigneeUserId)
      }
      if(![undefined,null].includes(this.selectedPAMPriority) && this.selectedPAMPriority != 'All'){
        payload.params.priority = this.selectedPAMPriority
      }
      if(![undefined,null].includes(this.selectedPAMStatus) && this.selectedPAMStatus != 'All'){
        payload.params.status = this.selectedPAMStatus;
      }
      if (![undefined,null].includes(this.keywordFilter) && this.keywordFilter.length){
        payload.params.keyword = this.keywordFilter;
      }
      this.filesList = { dirs: [], files: [] }
      this.getServerTicketsData(payload).then((data) =>{
        this.filesList["files"] = data["tasks"];
        this.totalPages = data["page_count"];
        this.page = data["page"];
        this.totalFiles = data["total_tasks"];
        this.perPage = data["tasks_per_page"]
      });    
    },
    getPriorityIcon(priority){
            let priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill:"#f7ab00" stroke="#f7ab00"/>
                                </svg>`;
            if(priority == "Highest"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb3a0e" stroke="#fb3a0e"/>
                                    </svg>`;
            }else if(priority == "High"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb572f" stroke="#fb572f"/>
                                    </svg>`;
            }else if(priority == "Medium"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill:"#f7ab00" stroke="#f7ab00"/>
                                    </svg>`;
            }else if(priority == "Low"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"  stroke="#b5b5b5">
                                        <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                                    </svg>`;   
            }else if(priority == "Lowest"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16" stroke="#808080">
                                        <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                                    </svg>`;   
            }

            return priorityIcon;
    },
    seeMoreDescription(id){
      if(!this.descriptionVisibilityArr.includes(id)){
        this.descriptionVisibilityArr.push(id)
      }
    },
    getStatusIcon(status){
            // let statusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
            //                     <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            //                 </svg>`;

            let statusIcon = "New";
            if(status == "In Progress"){
                statusIcon = `<svg data-v-976a8266="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" viewBox="0 0 16 16" class="bi bi-clock-fill"><path data-v-976a8266="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"></path></svg>`;
                
            }else if(status == "Done"){
                statusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#57af57" viewBox="0 0 16 16" class="bi bi-check-circle-fill"><path data-v-976a8266="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path></svg>`;
            }

            return statusIcon;
    },
    getProjectOptionsList(recallList){
      this.getServerProjectsData().then((data) =>{
        // if(Utils.isAcceptedStatusCode(data.status)){
          this.allProjectsList= data.projects;
          if(!(["tasks-display-component","issues-display-component"].includes(this.selectedComponent))){
            this.allProjectsList.unshift({"project_name":"All", "short_code":"All","_id":"All"});
          }
          // if(![undefined, null].includes(JSON.parse(localStorage.getItem('selected_project_obj'))){
          //   this.selectedProject = JSON.parse(localStorage.getItem('selected_project_obj')
          // }else{
            this.selectedProject = this.allProjectsList[0];
          //   localStorage.setItem("selected_project_obj", JSON.stringify(this.selectedProject)).projects;
          // }
          if(recallList){
            this.initPAMBrowse(true)
          }
        // }  
      });    
    },
    onProjectChangeOnFilter(option){
      this.selectedProject = option;
      this.initPAMBrowse(false);
    },
    handleFavouriteUserRemoved(user){
       console.log(`[handleFavouriteUserRemoved]`,user);
       this.favouriteUserId = null;
       this.refreshCAssetsList({});
    },
    handleFavouriteUserChange(user){
      console.log(`[handleFavouriteUserChange]`,user);
      if(user._id == 'all'){
         this.favouriteUserId = null;
      }else{
         this.favouriteUserId = user._id;
      }
      this.refreshCAssetsList({});
    },
    handleCreatedByUsersList(user){
      if(user._id == 'all'){
        this.createdByUserId = "";
      }else if(this.createdByUserId != user._id){
        this.createdByUserId = user._id;
      }
      this.initPAMBrowse(false);
    },
    handleCreatedByRemovedUserFromList(user){
      if(this.createdByUserId == user._id){
        this.createdByUserId = ""
      }
      this.initPAMBrowse(false);
    },
    handleAssigneeUsersList(userId){
      if(userId == 'all'){
        this.assigneeUserId =[]
      }
      else if(!this.assigneeUserId.includes(userId)){
        this.assigneeUserId.push(userId);
      }
      this.initPAMBrowse(false);
    },
    handleAssigneeRemovedUserFromList(user){
      if(this.assigneeUserId.includes(user._id)){
        this.assigneeUserId.splice(this.assigneeUserId.indexOf(user._id), 1)
      }
      this.initPAMBrowse(false);
    },
    onPAMPriorityChange(option){
      this.selectedPAMPriority = option;
      this.initPAMBrowse(false);  
    },
    onPAMStatusChange(option){
      this.selectedPAMStatus = option;
      this.initPAMBrowse(false);  
    },

    getPrefferedUserTypes(){
        if(['SystemAdmin','SystemUser'].includes(this.getLoggedInUserType())){
            return ['SystemAdmin','SystemUser'];
        }
        return [];
    },

    closeModalCompoent(){
      if (this.parentRouteInfo && Object.keys(this.parentRouteInfo)!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
        this.$router.push({
          name: this.parentRouteInfo.name,
          params:this.parentRouteInfo.params,
          query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
        })
      }else{
        this.$router.push({
          name: "explorer",
        })
      }
    },

    registertoWSListener(){
      this.addWSEventListener({eventname:NotifierConstants.fileCreatedNotification, callback:this.handleFileCreateNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileRemovedNotification, callback:this.handleFileRemovedNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.binRemovedNotification, callback:this.handleBinRemovedNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleFileArchivedNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.assetCreatedNotification, callback:this.handleAssetCreatedNotificaton,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.assetRemovedCreatedNotification, callback:this.handleAssetRemovedNotification,parent:"BinsBrowse"})
    },
    ...mapActions("assets", ["getAllAssetsFromServer","getAssetInfoFromServer"]),
    ...mapMutations("categories", ["setSelectedCategoryInCategoryBrowse"]),
    ...mapActions("files", ["getAllFilesFromServer","getSearchKeywordAutoComplitionFromServer"]),
    ...mapMutations("bins",["setSelectedPath","setPermissionOfSelectedBin"]),
    ...mapMutations("websocket",["addWSEventListener"]),
    ...mapActions("PAM", ["getServerTicketsData", "getServerIndTaskData","getServerProjectsData"]),
    ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserType"]),
    ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
  },
  created() {
    Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
    if(this.allowedPermissions && this.allowedPermissions.length > 0){
      this.defaultPermissions = this.allowedPermissions
    }
    let ccLoaded = false;
    // if(this.parentPreSelectedPathIds){
    //   this.preSelectedPathIds = this.parentPreSelectedPathIds
    // }
    if(this.browseOnlyFolders){
      this.enableOnlyFolders = this.browseOnlyFolders
    }
    if(this.workspaceList.length == 1){
      this.resizeAssetsWidth = "100%";
    }else{
      this.resizeAssetsWidth = "94%";
    }
    if(this.workspaceList.includes(Constants.WORKSPACE_CATALOG) && this.isPEnabled("catalogs-workspace")){
      this.vWorkspace[Constants.WORKSPACE_CATALOG] = true;
      this.browseContext = "catalogs-display";
      ccLoaded = true;
      this.selectedComponent = "catalogs-display-component";
      this.usedByCLabel = "Catalogs";
      this.setRootElement().then(()=>{
        this.initCBrowse();
      }); 
    }else{
      this.vWorkspace[Constants.WORKSPACE_CATALOG] = false;
    }
    if(this.workspaceList.includes(Constants.WORKSPACE_BINS) && this.isPEnabled("bins-workspace")){
      this.vWorkspace[Constants.WORKSPACE_BINS] = true;
      if(!ccLoaded){
        ccLoaded = true;
        this.selectedComponent = "bins-display-component";
        this.usedByCLabel = "Bins";
        this.browseContext = "bins";
      }
    }else{
      this.vWorkspace[Constants.WORKSPACE_BINS] = false;
    }
    if(this.workspaceList.includes(Constants.WORKSPACE_TICKETS) && this.isPEnabled("Ticket")){
      this.vWorkspace[Constants.WORKSPACE_TICKETS] = true;
      if(!ccLoaded){
        this.pamWorkspaceType = 'Ticket';
        this.browseContext = "tickets";
        ccLoaded = true;
        this.selectedComponent = "tickets-display-component";
        this.getProjectOptionsList(true);
      }
    }else{
      this.vWorkspace[Constants.WORKSPACE_TICKETS] = false;
    }
    
    if(this.workspaceList.includes(Constants.WORKSPACE_TASKS) && this.isPEnabled("Projects")){
      this.vWorkspace[Constants.WORKSPACE_TASKS] = true;
      if(!ccLoaded){
        this.pamWorkspaceType = "Task"
        this.browseContext = "tasks";
        ccLoaded = true;
        this.selectedComponent = "tasks-display-component";
        this.getProjectOptionsList(true);
      }
    }else{
      this.vWorkspace[Constants.WORKSPACE_TASKS] = false;
    }
    
    if(this.workspaceList.includes(Constants.WORKSPACE_ISSUES) && this.isPEnabled("Projects")){
      this.vWorkspace[Constants.WORKSPACE_ISSUES] = true;
      if(!ccLoaded){
        this.pamWorkspaceType = "Issue"
        this.browseContext = "issues";
        ccLoaded = true;
        this.selectedComponent = "issues-display-component";
        this.getProjectOptionsList(true);
      }
    }else{
      this.vWorkspace[Constants.WORKSPACE_ISSUES] = false;
    } 

    // if(this.vWorkspace['catalog']){
    // }else if(this.vWorkspace['bins']){
    // }

    this.registertoWSListener()
  },
  beforeDestroy() {
    this.isdestroyed = true;
    if(this.resizeObservor)this.resizeObservor.disconnect();
  },
  props: ["enableAssetMultiSelect", "workspaceList", "customModelTitle","browseOnlyFolders","enableRecursive","parentPreSelectedPathIds","allowedPermissions", "supportedBrowseMimeType"],
  data() {
    return {
      parentIPList:[],
      selectedAssetId:"",
      enableOICBrowse:false,
      descriptionVisibilityArr:[],
      parentRouteInfo:{},
      selectedPAMStatus:'All',
      reviewStatusList:["All", "New", "In Progress", "Done",],
      selectedPAMPriority:'All',
      reviewPriorityList:["All", "Highest", "High", "Medium", "Low", "Lowest"],
      assigneeUserId:[],
      createdByUserId:"",
      selectedProject:{},
      allProjectsList:[],
      viewPamEntryDetails:false,
      vWorkspace:{},
      vCWorkspace:false,
      vBWorkspace:false,
      eOMenu:false,
      selectedCatalog:{},
      rootElement:{},
      showOtherFilesPreviewDialog:false,
      openPip:false,
      gridView:true,
      enableAdvancedSearch:false,
      browseContext:'',
      pamWorkspaceType:"",
      resizeObservor:null,
      resizedHeight:"100%",
      resizeAssetsWidth:"94%",
      advanceSearchKeys:null,
      selectedBinId:"",
      rootPathPermission:null,
      showCatalogs:true,
      lastSearch:[],
      searchedValue:[],
      keywordFilter:[],
      searchKeywordListFromAutocomplete:[],
      selectedComponent:"",
      logo: Utils.getLogo(),
      usedByCLabel:"",
      showBins: false,
      isdestroyed: false,
      filesList: { dirs: [], files: [] },
      binSelected: null,
      page: 1,
      selected: [],
      totalPages: -1,
      totalFiles: -1,
      perPage: -1,
      folderStructure: [],
      currentFolderInfo: {},
      selectedFileInfo: {},
      selectedExternalPluginInfo: {},
      options: { chunk: 5 },
      growingFileGif: Utils.getLoadingGif(),
      markForDeleteIcn: Utils.getMarkForDeleteIcon(),
      selectedFiles:{},
      dragSelected:false,
      fileUuids:[],
      sortBy:{label:'Relevance',sortOn:'added_datetime',ascDesc:-1},
      showFolders:true,
      showFiles:true,
      allFilesSelected:false,
      enableOnlyFolders: false,
      activeIndexInfo:{
          "path":"",
          "apply_recursively":false
        },
      preSelectedPathIds:[],
      defaultPermissions:["full-control","read-modify","read-write","read"],
      favouriteUserId:null,
    };
  },
};
</script>

<style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $secondary-border-color: 1px solid #2b2b2b;
  $icon-hover:#2c3339;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555; 
  $input-field-padding:.375rem 10px;
  $filter-border-color: #5a5a5a;
  $filter-bg-color: #2a2a2a;
  $row-border-color: #212121;


.activeAsset,.activeMultipleAssets {
  border: 2px solid #037afb !important;
  border-radius: 5px !important;
  .thumbnail-data {
    background: #1879e28c !important;
    position: relative;
    width: 102%;
    inset-inline-start: -4px;
    .svg-icons-display {
      inset-inline-end: 0px;
      bottom: -1px;
    }
  }
}
.asset-thumbnail-hw-set{
  height:78px;
  width:130px;
  border-radius: 7px;
  border: $border-color;
  .thumbnail-hw-set{
    height:100%;
    position: relative;
    align-items: center;
    display: inline-flex;
    justify-content:center;
    img{
      max-width: 100%;
      max-height: 100%;
      border-radius: 7px;
      object-fit: contain;
      border-radius: 7px;
    }
  }
}
.activeAsset.active-list-view {
  color: $active-blue;
  border: none !important;
}
// .thumbnail-view-ul{
//   li:hover{
//     border: $border-color;
//     border-radius: 5px;
//   }
// }
.thumbnail-view-ul {
  list-style-type: none;
  display: inline-flex;
  flex-wrap: wrap;
  padding: 0px;
  margin-top: 0px;
  width: 100%;
  padding-inline-start: 20px;
  justify-content: start;
  overflow: auto;
  height: auto;
  // position:relative; 
  li {
    display: inline-block;
    margin-inline-end: 10px;
    width: 174px;
    padding-inline-start: 5px;
    margin-top: 5px;
    height: 128px;
    .asset-thumbnail {
      height: 93px;
      width: 160px;
      border-radius: 7px;
      margin-top: 8px;
      border: $border-color;
      position:relative;
      .thumbnail-view{
        height:100%;
        position: relative;
        align-items: center;
        display: inline-flex;
        justify-content:center;
        img{
          max-width: 100%;
          max-height: 100%;
          border-radius: 7px;
          object-fit: contain;
          border-radius: 7px;
        }
      }
    }
    .thumbnail-data {
      text-align: center !important;
    }
  }
}
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
.folder-view-ul {
  padding-top: 4px;
  margin-bottom: 4px;
  .folder-view-li {
    display: inline-flex !important;
    height: 46px !important;
    border: $border-color;
    border-radius: 6px;
    .folder-view {
      font-size: 30px;
    }
    .folder-data {
      margin-top: 15px;
      margin-inline-start: 7px;
      width: 118px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: start;
    }
  }
}

.activeFolder {
  border: 1px solid $active-blue !important;
  color: $active-blue !important;
  .folder-view {
    svg {
      color: $active-blue !important;
    }
  }
}

.assets-view-wrapper {
  height: 100% !important;
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
  width: 100%;
}

.list-view-wrapper {
  height:100% !important;
  overflow: auto;
  display: inline-block;
  width: 100%;
  li{
    margin:0px 5px ;
  }
}

.storage-type-icons-wrapper,.storage-type-icons-wrapper-list-view{
  position: absolute;
  svg{
    margin:3px;
  }
}

.storage-type-icons-wrapper-list-view{
  color: $dull-text-color;
  inset-inline-end: 0px;
}
.storage-type-icons-wrapper{
 color: #999;
  background: #1a1a1ab3;
  min-width: 30px;
  width: auto;
  inset-inline-end: -1px;
  bottom: -1px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 4px;
}
.shortcut-actions-type-icons-wrapper{
        visibility: hidden;
        color: #999;
        background: #000000c9;
        min-width: 30px;
        width: auto;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        position: absolute;
        top: 6px;
        inset-inline-end: 6px;
        line-height: 1;
        margin-inline-start: 8px;
        border: unset;
        --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
        box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
        display: flex;
        padding: 2px;
        border-radius: 0.375em;
        svg{
            margin-inline-start: 6px;
            margin-inline-end: 6px;
        }
    }
    .asset-thumbnail:hover,.asset-thumbnail-hw-set:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
        }
    }
    .overflow-parent-div {
      .overflow-menu{
        background: #1e1e1e;
        font-size: 14px !important;
        height: 60px;
        border: 1px solid #757575;
        top: 19px;
        display: inline-block;
        inset-inline-start: calc(100% - 25px);
        padding-top: 3px !important;
        // visibility: hidden;
      }
    }
    .thumbnail-hw-set:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
        }
    }
    .shortcut-actions-type-icons-wrapper svg:hover{
        fill: #fdfff4;
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action:hover{
        background:#2a2c2e !important
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action{
        svg{
          fill: #EEE;
        }
        color: #EEE;
        height: 25px;
        align-items: center;
        display: flex;
    }

    .dropdown-menu{
      background-color:$secondary-background-color !important;
      border: $border-color;
    .dropdown-item{
      color:$text-color;
      font-size:14px !important; 
      }
  }

  .dropdown-item:hover{
      background-color:$bg-color-on-hover !important;
  }
  .nav-item{
      color: $secondary-text-color !important;
  }

  .dropdown-toggle:after{
    display:none !important;
  }

.clear-icon{
  fill: #a1a1a1 !important;
  position:absolute;
  inset-inline-end:38px;
  bottom:12px;
  z-index:111;
}
  //   .dropdown-menu{
  //     background-color:#202020 !important;
  //     border: $border-color;
  //     .dropdown-item{
  //     color:$text-color;
  //     font-size:14px !important; 
  //     }
  // }

  .dropdown-item:hover{
      background-color:$bg-color-on-hover !important;
      color: $text-color !important;
  }
  .nav-item{
      color: $dull-text-color !important;
  }

  .dropdown-toggle:after{
    display:none !important;
  }
.search-icon{
  fill: #a1a1a1;
  position:absolute;
  inset-inline-start: 96%;
  top:10px;
  z-index:111
}
.slider-icon{
    fill: #a1a1a1;
  }
.slider-icon:hover, .search-icon:hover, .clear-icon{
    fill: #fff;
  }

// //pagination
::v-deep {
   #sortBy_multiselect .multiselect__tags,#sortBy_multiselect .multiselect__select{
      min-height: 40px !important;
      height: 40px !important;
      max-height: 40px !important;
   }
   nav[aria-label="breadcrumb"]{
       display: none !important;
   }
  [v-cloak] .hide-picture{
    display: none;
  }
  [v-cloak] .hide-element-util-mount{ //sometimes un-necessary preview dialog was showing to hide code is required
    display: none;
    }
    .hide{
        display:none;
    }
  .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-start;
    display: none;
    margin-inline-start: 5px;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-prev-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page a:before {
    width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    width: 50px;
    content: " prev";
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 200px !important;
    z-index: 9 !important;
  }

 // for multiselect
  div[data-drag-box-component]{
      z-index:3000;
  }
  
    .search-bar-autocomplete-wrapper{
      .multiselect__content-wrapper{
        display:none;
      }
      .multiselect__tag {
        background-color: $primary-background !important;
      }
      .multiselect__tags{
          background: $primary-background !important;
          border: $border-color !important;
      }
      .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
      .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 23px;
      }
      .multiselect *{
          font-size: $input-field-and-label-font-size !important;
          font-family: "Roboto", Arial, sans-serif !important;
      }
      .multiselect__placeholder {
        padding-top: 0px;
        padding-inline-start: 5px !important;
      }
      .multiselect{
        color:$text-color !important;
        font-size: $input-field-and-label-font-size !important;
        width:100%;
        min-height: 42px !important;
        height: 42px !important;
        margin:0px !important;
        padding: 0px !important;
        //border: 1px solid #4a4a4a;
      }
      .multiselect__option--selected{
          background: $bg-color-on-hover !important;
          color: $text-color;
      }
      .multiselect__content-wrapper{
          border: 1px solid $bg-color-on-hover !important;
          position: relative;
          display: block;
          background: #333 !important;
          width: 100%;
          max-height: 240px;
          overflow: auto;
          border: 1px solid $text-color;
          border-top: none;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          z-index: 50;
          -webkit-overflow-scrolling: touch;
      }
      .multiselect__select,.multiselect__current,.multiselect__option{
          line-height: 12px !important;
      }
      .multiselect__select{
        display: none !important;
      }
      .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
      }
      .multiselect__tags {
          background: $primary-background!important;
          height: $input-field-height;
          min-height: 38px;
      }
    }
}
    .sidenav{
      height: calc(100vh - 160px);
      border-top: none;
      padding:0px;
      .sidebar{
        background: $secondary-background-color;
        color: $secondary-text-color;
        height:70px;
        padding-top: 13px !important;
      }
      .sidebar:hover{
        color: $text-color;
        background: $primary-background !important;
      }
    }

  .sidebar-main{
    background: $secondary-background-color;
  }
 .search-bar{
    // border:$border-color !important;
    background: $primary-background !important;
    width:100%;
    height:30px;
    margin-inline-start:2%;
    pointer-events: all;
    color: $text-color !important;
    padding-inline-start: 14px;
  }
  .activePanel{
    color:$active-blue !important;
    background: $primary-background !important;
    svg{
      color:$active-blue !important;
      fill:$active-blue !important;
    }
  }

.icon-background-on-hover:hover{
  background: #d1d2d31a;
}

.icon-background-on-hover{
  padding: 6px;
  height: 28px;
  width: 28px;
  border-radius: 4px;
}

.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  margin: 0px 15px;
  thead {
    color: $dull-text-color !important;
    position: relative;
    width: 100%;
    th {
      position: sticky;
      top: 0;
      background: $primary-background;
      z-index: 9;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr {
      height: 60px;
    }
  }
}

.table {
  th {
    border-top: none !important;
  }
  td {
    border-top: none !important;
  }
}

.table-with-border {
  thead {
    border-bottom: $border-color;
  }
  tr {
    border-bottom: $border-color;
  }
}

.thumbnail-hw-set {
  height: 68px;
  width: 120px;
  border-radius: 93%;
  img {
    height: 100%;
    width: 100%;
    border-radius: 7px;
  }
}

input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block;
  width: 22px;
  height: 21px;
  margin-top: -1px;
  margin-inline-start: -1px;
  border: $border-color;
  border-radius: 0.25em;
  background: $primary-background;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.thumbnail-data {
  svg {
    border-radius: 5px;
    height: 100%;
    width: 100%;
  }
}

.reduce-opacity{
  opacity: 0.67
}

.svg-icons-display {
  height: 20px;
  width: 20px;
  position: relative;
  opacity: 0.8;
  inset-inline-end: 5px;
}

.file-name {
  white-space: nowrap;
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: initial;
  position: relative;
  inset-inline-start: 2px;
  top: 2px;
}

.change-the-text-color{
  color: $dull-text-color;
  text-transform: uppercase;
  height: 22px;
  width: fit-content;
  border: 1px solid #F49D1A;
  border-radius: 10px;
  padding: 3px 9px;
  color: #F49D1A;
  font-size: 10px;
  letter-spacing: 0.5px;
}

.dull-the-text {
  color: #9c9c9c;
}
.comm-lengthy-value-styles {
  white-space: normal;
  word-break: break-all;
}

.file-name-display-styles-in-list-view{
  white-space: normal;
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: initial;
  position: relative;
  inset-inline-start: -2px;
  top: 2px;
  word-break: break-all;
}
.modal-dialog {
    //max-width: calc(100% - 90px) !important;
    //width: calc(100% - 86px) !important;
    //height: 90%;
    max-width: 100vw !important;
    width: 100vw !important;
    height: 100vh !important;
    margin: 0;
    padding: 0;
  }

  .blaze-fusion-browse{
     width: 100% !important;
     max-width:100% !important;
     height:100%;
  }

  .blaze-fusion-browse-top-0{
     top: 0 !important;
  }

  .blaze-fusion-browse-full-height{
     height:  100% !important;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
      user-select: text !important; 
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top:0;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

.modal-header .close {
    margin: 0px !important;
    padding:0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    width: 25%;
    z-index: 9999;
    justify-content: flex-end;
    button{
        height: 35px;
        width: 70px;
    font-size:14px;
    }
}
.primary-btn-style button:disabled {
  color: gray;
  border: 1px solid gray;
}
.secondary-btn-style{
  color:$text-color;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.nav-item{
    color: $dull-text-color !important;
}

.active{
    background: $primary-background !important;
    color: #bbb !important;
}
.top-nav-bar{
  text-align: center;
    background: $secondary-background-color;
}
.table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        margin: 0px 15px;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th {
            position: sticky;
            top: 0;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 45px;
            }
            tr:hover{
                background: $bg-color-on-hover;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
        }
        td {
            border-top: none !important;
        }
    }

    th {
        border-top: none !important;
    }

    .table-cell-styles{
        td{
            padding:10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }
    
    .user-name-or-image{
      height: 30px;
      width: 30px;
      border: $border-color;
      border-radius: 10px;
      text-align: center;
      line-height: 28px;
      text-transform: uppercase;
      margin-inline-end: -7px;
    }    

    .user-name{
        margin-inline-end: 10px;
        position: relative;
        bottom: 7px;
    }
    .user-name-align{
        text-align: start;
        word-break: break-word;
    }

    svg.svg-icon {
        width: 20px;
        height: 20px;
    }
    .comm-more-users-style{
        font-size: 12px!important;
        color: #000;
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        display: inline-block;
        background: $bg-color-on-hover;
    }

    .config-label {
        width: 26% !important;
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
    }
  
    .config-value {
        margin-inline-start: 4px;
        width: 99% !important;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }
    .show-delete-icon:hover{
        .parent-comment-delete, .parent-comment-view{
            visibility: visible;
        }
    }

    .parent-comment-delete, .parent-comment-view{
        margin-inline-start: 10px;
        position: absolute;
        inset-inline-end: 0px;
        z-index: 1;
        background: #525252;
        border: 1px solid #262626;
        width: 55px;
        height: 44px;
        padding: 12px;
        top: 0px;
        border-radius: 0px 5px 5px 0px;
        visibility: hidden;
    }

    .parent-comment-view{
        inset-inline-end:54px;
        border-radius: 5px 0px 0px 5px;
    }
    .comm-tag-title-hover:hover{
        text-decoration: underline;
    }

    ::v-deep {
      .multiselect {
          color:$text-color !important;
      }
      .projectDropdownFilter{
        .multiselect {
          width:100%;
          margin-bottom: 4px;
          color:$text-color;
        }
        .multiselect__content-wrapper {
          display: none;
        }
        .multiselect__tag, .tags-style {
          background-color: $primary-background !important;
          border: $border-color;
          border-radius: 5px;
          margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
          background: $primary-background !important;
              border: $border-color !important;
        }

        .name-count-parent-wrap{
          background: transparent !important;
          border: none !important;
        }

        
        .multiselect__option--highlight {
          background: $bg-color-on-hover !important;
        }
        .multiselect__content {
          background: $secondary-background-color !important;
        }
        .multiselect__input,
        .multiselect__single {
          background: transparent !important;
          color: $text-color;
        }
        .multiselect__input:focus {
          outline: none;
          box-shadow: none;
        }
        .multiselect__tag-icon {
          color: $text-color !important;
        }
        .multiselect__tag-icon:focus,
        .multiselect__tag-icon:hover {
          background: $bg-color-on-hover !important;
          color: $text-color !important;
        }
        .multiselect__tag-icon:after {
          color: $secondary-text-color !important;
          font-size: 23px;
        }

        .multiselect__tag-icon {
          visibility: hidden;
        }

        .multiselect__tag:hover .multiselect__tag-icon {
          visibility: visible;
        }

        .multiselect * {
          font-size: $input-field-and-label-font-size !important;
          font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__placeholder {
          padding-top: 3px !important;
          margin-bottom:0px !important;
        }
        .multiselect {
          color: $text-color !important;
          font-size: $input-field-and-label-font-size !important;
          width: 99%;
          min-height: 38px;
        }
        .multiselect__single {
          padding-top: 3px;
          margin-bottom:0px;
        }
        .multiselect__option--selected {
          background: $bg-color-on-hover !important;
          color: $text-color;
        }
        .multiselect__content-wrapper {
          border: 1px solid $bg-color-on-hover !important;
          position: absolute;
          display: block;
          background: $text-color;
          width: 100%;
          max-height: 240px;
          overflow: auto;
          border: 1px solid $text-color;
          border-top: none;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          z-index: 50;
          -webkit-overflow-scrolling: touch;
        }

        .multiselect__current,
        .multiselect__option {
          line-height: 12px !important;
        }

        .multiselect--above .multiselect__content-wrapper {
          background: $secondary-background-color !important;
        }
        .multiselect__tags {
          background: $primary-background !important;
          height: auto;
          padding: 8px 40px 8px 8px;
          // min-height: 42px !important;
        }
        
        .mx-input{
            background-color:$primary-background !important;
            border: none !important;
            color: $text-color !important;
            height:100%;
        }
        .mx-input-wrapper{
            width:100%;
            height:100%;
        }
        .mx-datepicker-main{
            border: $border-color  !important;
            background: $primary-background!important;
        }
        .mx-calendar-content .cell:hover{
            background-color: $bg-color-on-hover !important;
        }
        .mx-datepicker-range{
            width:100%;
            height:100% !important;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-datepicker{
            width:100% !important;
            padding: 0 !important;
            border:$border-color !important;
            height: 27px !important;
        }
        .mx-icon-calendar, .mx-icon-clear{
            color: #d7d2d280;
        }


        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-end;
            margin-inline-start:5px;
            position: relative;
            top: 5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
        }
        .v-menu__content{
            width:150px !important;
        }
        .multiselect__tag {
            background-color: #131313;
        }
        .multiselect__tags{
            background: #161616;
            border: 1px solid #202020;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
             color:$text-color;
            align-items: center;
            margin:0px !important;
            height: 100%;
            padding-inline-start: 5px;
            padding-top: 0px !important;
        }
        .multiselect__single {
            margin: 0px !important;
            height: 100%;
            display: flex;
            align-items: center;
        }  
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
            color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 23px;
        }
        .multiselect *{
            font-size: 14px !important;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: 12px !important;
            height: $input-field-height;
            min-height: $input-field-height;
        }
        .multiselect__option--selected{
           background: $bg-color-on-hover !important;
           color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: relative;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 240px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
          background: #1A1A1A !important;
        }
        .multiselect__tags {
            height: auto;
            padding-inline-start: 8px !important;
        }

        .multiselect__placeholder{
            display: flex;
            align-items: center;
            margin:0px !important;
            height: 100%;
            padding-inline-start: 5px;

        }
      }
}
    
.custom-control-input:checked~.custom-control-label:before {
    color: #fff;
    border-color: #007bff;
    background-color: #007bff !important;
}


.custom-control-input{
  z-index: 9999;
}


.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    // position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}
.overWriteContainer{
  padding-inline-start: 0px !important;
}
.overWriteContMargin{
  margin-inline-start: 24px !important;
}
// .overWriteAdvIcon{
//   inset-inline-end :calc(100% - 713px) !important;
// }


.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
.bigger-checkboxes:focus{
  box-shadow: unset;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}
.custom-control-label{
    line-height:25px;
}

.custom-control-input:checked~.custom-control-label:before {
    color: #fff;
    border-color: #007bff;
    background-color: #007bff !important;
}

.config-desc,.custom-control{
  width: 100%;
  text-align: initial;
}

.custom-switch .custom-control-label::before{
    background: transparent;
}

  .thumbnail-view-resolution-label{
    color: #eee;
    position: absolute;
    top: 0px;
    inset-inline-start: 0px;
    font-size: 10px;
    padding: 1px 5px;
    justify-content: center;
    display: flex;
    border-radius: 7px;
    align-items: center;
    margin: 2px;
  }
  .res-FHD{
    // background: rgba(248, 120, 0, 0.6) !important;
    background: #f87800 !important;
    border: 1px solid #4a4a4a;
  }
  .res-fourK{
    background: #f8090199 !important;
    border: 1px solid #4a4a4a;
    //background: rgba(248, 9, 1, 0.6) !important;
  }
  .res-HD{
    // background: rgba(245, 241, 4, 0.6) !important;
    background: #f5f10499 !important;
    border: 1px solid #4a4a4a;
    color: #292a2b !important;
  }
  .res-SD{
    // background: rgba(29, 134, 140, 0.952) !important;
    background: #1d868cf3 !important;
    border: 1px solid #4a4a4a;
}

.favourite-assets-wrapper{
   height: 100% !important;
}
</style>
